/* Generated by FCC Render Batch/build_manifest.js; do not hand-edit. */
window.RENDER_MANIFEST = {
 "generated": "2026-09-28T14:10:00.012Z",
 "base": "renders",
 "views": {
  "Full Set (Front + Back)": "full",
  "Fronts Only": "fronts",
  "Backs Only": "backs"
 },
 "folderRule": "main === secondary ? main : main + \"_\" + secondary",
 "defaultPattern": "Diamond",
 "patterns": {
  "Basic": {
   "available": {
    "Aqua Blue_Aqua Blue": true,
    "Aqua Blue_Beige": true,
    "Aqua Blue_Black": true,
    "Aqua Blue_Charcoal Grey": true,
    "Aqua Blue_Dark Mocha": true,
    "Aqua Blue_Dark Orange": true,
    "Aqua Blue_Dark Purple": true,
    "Aqua Blue_Dark Saddle Brown": true,
    "Aqua Blue_Deep Teal": true,
    "Aqua Blue_Espresso Brown": true,
    "Aqua Blue_Golden Yellow": true,
    "Aqua Blue_Lavender": true,
    "Aqua Blue_Light Grey": true,
    "Aqua Blue_Lime Green": true,
    "Aqua Blue_Mid Grey": true,
    "Aqua Blue_Midnight Blue": true,
    "Aqua Blue_Olive Green": true,
    "Aqua Blue_Orange": true,
    "Aqua Blue_Peanut Butter": true,
    "Aqua Blue_Pink": true,
    "Aqua Blue_Red": true,
    "Aqua Blue_Royal Blue": true,
    "Aqua Blue_Saddle Brown": true,
    "Aqua Blue_Sage Grey": true,
    "Aqua Blue_Sand": true,
    "Aqua Blue_Sky Blue": true,
    "Aqua Blue_Slate Blue": true,
    "Aqua Blue_Slate Grey": true,
    "Aqua Blue_Soft Plum": true,
    "Aqua Blue_Steel Blue": true,
    "Aqua Blue_Warm Khaki": true,
    "Aqua Blue_White": true,
    "Aqua Blue_Wine Red": true,
    "Beige_Beige": true,
    "Beige_Aqua Blue": true,
    "Beige_Black": true,
    "Beige_Charcoal Grey": true,
    "Beige_Dark Mocha": true,
    "Beige_Dark Orange": true,
    "Beige_Dark Purple": true,
    "Beige_Dark Saddle Brown": true,
    "Beige_Deep Teal": true,
    "Beige_Espresso Brown": true,
    "Beige_Golden Yellow": true,
    "Beige_Lavender": true,
    "Beige_Light Grey": true,
    "Beige_Lime Green": true,
    "Beige_Mid Grey": true,
    "Beige_Midnight Blue": true,
    "Beige_Olive Green": true,
    "Beige_Orange": true,
    "Beige_Peanut Butter": true,
    "Beige_Pink": true,
    "Beige_Red": true,
    "Beige_Royal Blue": true,
    "Beige_Saddle Brown": true,
    "Beige_Sage Grey": true,
    "Beige_Sand": true,
    "Beige_Sky Blue": true,
    "Beige_Slate Blue": true,
    "Beige_Slate Grey": true,
    "Beige_Soft Plum": true,
    "Beige_Steel Blue": true,
    "Beige_Warm Khaki": true,
    "Beige_White": true,
    "Beige_Wine Red": true,
    "Black_Black": true,
    "Black_Aqua Blue": true,
    "Black_Beige": true,
    "Black_Charcoal Grey": true,
    "Black_Dark Mocha": true,
    "Black_Dark Orange": true,
    "Black_Dark Purple": true,
    "Black_Dark Saddle Brown": true,
    "Black_Deep Teal": true,
    "Black_Espresso Brown": true,
    "Black_Golden Yellow": true,
    "Black_Lavender": true,
    "Black_Light Grey": true,
    "Black_Lime Green": true,
    "Black_Mid Grey": true,
    "Black_Midnight Blue": true,
    "Black_Olive Green": true,
    "Black_Orange": true,
    "Black_Peanut Butter": true,
    "Black_Pink": true,
    "Black_Red": true,
    "Black_Royal Blue": true,
    "Black_Saddle Brown": true,
    "Black_Sage Grey": true,
    "Black_Sand": true,
    "Black_Sky Blue": true,
    "Black_Slate Blue": true,
    "Black_Slate Grey": true,
    "Black_Soft Plum": true,
    "Black_Steel Blue": true,
    "Black_Warm Khaki": true,
    "Black_White": true,
    "Black_Wine Red": true,
    "Charcoal Grey_Charcoal Grey": true,
    "Charcoal Grey_Aqua Blue": true,
    "Charcoal Grey_Beige": true,
    "Charcoal Grey_Black": true,
    "Charcoal Grey_Dark Mocha": true,
    "Charcoal Grey_Dark Orange": true,
    "Charcoal Grey_Dark Purple": true,
    "Charcoal Grey_Dark Saddle Brown": true,
    "Charcoal Grey_Deep Teal": true,
    "Charcoal Grey_Espresso Brown": true,
    "Charcoal Grey_Golden Yellow": true,
    "Charcoal Grey_Lavender": true,
    "Charcoal Grey_Light Grey": true,
    "Charcoal Grey_Lime Green": true,
    "Charcoal Grey_Mid Grey": true,
    "Charcoal Grey_Midnight Blue": true,
    "Charcoal Grey_Olive Green": true,
    "Charcoal Grey_Orange": true,
    "Charcoal Grey_Peanut Butter": true,
    "Charcoal Grey_Pink": true,
    "Charcoal Grey_Red": true,
    "Charcoal Grey_Royal Blue": true,
    "Charcoal Grey_Saddle Brown": true,
    "Charcoal Grey_Sage Grey": true,
    "Charcoal Grey_Sand": true,
    "Charcoal Grey_Sky Blue": true,
    "Charcoal Grey_Slate Blue": true,
    "Charcoal Grey_Slate Grey": true,
    "Charcoal Grey_Soft Plum": true,
    "Charcoal Grey_Steel Blue": true,
    "Charcoal Grey_Warm Khaki": true,
    "Charcoal Grey_White": true,
    "Charcoal Grey_Wine Red": true,
    "Dark Mocha_Dark Mocha": true,
    "Dark Mocha_Aqua Blue": true,
    "Dark Mocha_Beige": true,
    "Dark Mocha_Black": true,
    "Dark Mocha_Charcoal Grey": true,
    "Dark Mocha_Dark Orange": true,
    "Dark Mocha_Dark Purple": true,
    "Dark Mocha_Dark Saddle Brown": true,
    "Dark Mocha_Deep Teal": true,
    "Dark Mocha_Espresso Brown": true,
    "Dark Mocha_Golden Yellow": true,
    "Dark Mocha_Lavender": true,
    "Dark Mocha_Light Grey": true,
    "Dark Mocha_Lime Green": true,
    "Dark Mocha_Mid Grey": true,
    "Dark Mocha_Midnight Blue": true,
    "Dark Mocha_Olive Green": true,
    "Dark Mocha_Orange": true,
    "Dark Mocha_Peanut Butter": true,
    "Dark Mocha_Pink": true,
    "Dark Mocha_Red": true,
    "Dark Mocha_Royal Blue": true,
    "Dark Mocha_Saddle Brown": true,
    "Dark Mocha_Sage Grey": true,
    "Dark Mocha_Sand": true,
    "Dark Mocha_Sky Blue": true,
    "Dark Mocha_Slate Blue": true,
    "Dark Mocha_Slate Grey": true,
    "Dark Mocha_Soft Plum": true,
    "Dark Mocha_Steel Blue": true,
    "Dark Mocha_Warm Khaki": true,
    "Dark Mocha_White": true,
    "Dark Mocha_Wine Red": true,
    "Dark Orange_Dark Orange": true,
    "Dark Orange_Aqua Blue": true,
    "Dark Orange_Beige": true,
    "Dark Orange_Black": true,
    "Dark Orange_Charcoal Grey": true,
    "Dark Orange_Dark Mocha": true,
    "Dark Orange_Dark Purple": true,
    "Dark Orange_Dark Saddle Brown": true,
    "Dark Orange_Deep Teal": true,
    "Dark Orange_Espresso Brown": true,
    "Dark Orange_Golden Yellow": true,
    "Dark Orange_Lavender": true,
    "Dark Orange_Light Grey": true,
    "Dark Orange_Lime Green": true,
    "Dark Orange_Mid Grey": true,
    "Dark Orange_Midnight Blue": true,
    "Dark Orange_Olive Green": true,
    "Dark Orange_Orange": true,
    "Dark Orange_Peanut Butter": true,
    "Dark Orange_Pink": true,
    "Dark Orange_Red": true,
    "Dark Orange_Royal Blue": true,
    "Dark Orange_Saddle Brown": true,
    "Dark Orange_Sage Grey": true,
    "Dark Orange_Sand": true,
    "Dark Orange_Sky Blue": true,
    "Dark Orange_Slate Blue": true,
    "Dark Orange_Slate Grey": true,
    "Dark Orange_Soft Plum": true,
    "Dark Orange_Steel Blue": true,
    "Dark Orange_Warm Khaki": true,
    "Dark Orange_White": true,
    "Dark Orange_Wine Red": true,
    "Dark Purple_Dark Purple": true,
    "Dark Purple_Aqua Blue": true,
    "Dark Purple_Beige": true,
    "Dark Purple_Black": true,
    "Dark Purple_Charcoal Grey": true,
    "Dark Purple_Dark Mocha": true,
    "Dark Purple_Dark Orange": true,
    "Dark Purple_Dark Saddle Brown": true,
    "Dark Purple_Deep Teal": true,
    "Dark Purple_Espresso Brown": true,
    "Dark Purple_Golden Yellow": true,
    "Dark Purple_Lavender": true,
    "Dark Purple_Light Grey": true,
    "Dark Purple_Lime Green": true,
    "Dark Purple_Mid Grey": true,
    "Dark Purple_Midnight Blue": true,
    "Dark Purple_Olive Green": true,
    "Dark Purple_Orange": true,
    "Dark Purple_Peanut Butter": true,
    "Dark Purple_Pink": true,
    "Dark Purple_Red": true,
    "Dark Purple_Royal Blue": true,
    "Dark Purple_Saddle Brown": true,
    "Dark Purple_Sage Grey": true,
    "Dark Purple_Sand": true,
    "Dark Purple_Sky Blue": true,
    "Dark Purple_Slate Blue": true,
    "Dark Purple_Slate Grey": true,
    "Dark Purple_Soft Plum": true,
    "Dark Purple_Steel Blue": true,
    "Dark Purple_Warm Khaki": true,
    "Dark Purple_White": true,
    "Dark Purple_Wine Red": true,
    "Dark Saddle Brown_Dark Saddle Brown": true,
    "Dark Saddle Brown_Aqua Blue": true,
    "Dark Saddle Brown_Beige": true,
    "Dark Saddle Brown_Black": true,
    "Dark Saddle Brown_Charcoal Grey": true,
    "Dark Saddle Brown_Dark Mocha": true,
    "Dark Saddle Brown_Dark Orange": true,
    "Dark Saddle Brown_Dark Purple": true,
    "Dark Saddle Brown_Deep Teal": true,
    "Dark Saddle Brown_Espresso Brown": true,
    "Dark Saddle Brown_Golden Yellow": true,
    "Dark Saddle Brown_Lavender": true,
    "Dark Saddle Brown_Light Grey": true,
    "Dark Saddle Brown_Lime Green": true,
    "Dark Saddle Brown_Mid Grey": true,
    "Dark Saddle Brown_Midnight Blue": true,
    "Dark Saddle Brown_Olive Green": true,
    "Dark Saddle Brown_Orange": true,
    "Dark Saddle Brown_Peanut Butter": true,
    "Dark Saddle Brown_Pink": true,
    "Dark Saddle Brown_Red": true,
    "Dark Saddle Brown_Royal Blue": true,
    "Dark Saddle Brown_Saddle Brown": true,
    "Dark Saddle Brown_Sage Grey": true,
    "Dark Saddle Brown_Sand": true,
    "Dark Saddle Brown_Sky Blue": true,
    "Dark Saddle Brown_Slate Blue": true,
    "Dark Saddle Brown_Slate Grey": true,
    "Dark Saddle Brown_Soft Plum": true,
    "Dark Saddle Brown_Steel Blue": true,
    "Dark Saddle Brown_Warm Khaki": true,
    "Dark Saddle Brown_White": true,
    "Dark Saddle Brown_Wine Red": true,
    "Deep Teal_Deep Teal": true,
    "Deep Teal_Aqua Blue": true,
    "Deep Teal_Beige": true,
    "Deep Teal_Black": true,
    "Deep Teal_Charcoal Grey": true,
    "Deep Teal_Dark Mocha": true,
    "Deep Teal_Dark Orange": true,
    "Deep Teal_Dark Purple": true,
    "Deep Teal_Dark Saddle Brown": true,
    "Deep Teal_Espresso Brown": true,
    "Deep Teal_Golden Yellow": true,
    "Deep Teal_Lavender": true,
    "Deep Teal_Light Grey": true,
    "Deep Teal_Lime Green": true,
    "Deep Teal_Mid Grey": true,
    "Deep Teal_Midnight Blue": true,
    "Deep Teal_Olive Green": true,
    "Deep Teal_Orange": true,
    "Deep Teal_Peanut Butter": true,
    "Deep Teal_Pink": true,
    "Deep Teal_Red": true,
    "Deep Teal_Royal Blue": true,
    "Deep Teal_Saddle Brown": true,
    "Deep Teal_Sage Grey": true,
    "Deep Teal_Sand": true,
    "Deep Teal_Sky Blue": true,
    "Deep Teal_Slate Blue": true,
    "Deep Teal_Slate Grey": true,
    "Deep Teal_Soft Plum": true,
    "Deep Teal_Steel Blue": true,
    "Deep Teal_Warm Khaki": true,
    "Deep Teal_White": true,
    "Deep Teal_Wine Red": true,
    "Espresso Brown_Espresso Brown": true,
    "Espresso Brown_Aqua Blue": true,
    "Espresso Brown_Beige": true,
    "Espresso Brown_Black": true,
    "Espresso Brown_Charcoal Grey": true,
    "Espresso Brown_Dark Mocha": true,
    "Espresso Brown_Dark Orange": true,
    "Espresso Brown_Dark Purple": true,
    "Espresso Brown_Dark Saddle Brown": true,
    "Espresso Brown_Deep Teal": true,
    "Espresso Brown_Golden Yellow": true,
    "Espresso Brown_Lavender": true,
    "Espresso Brown_Light Grey": true,
    "Espresso Brown_Lime Green": true,
    "Espresso Brown_Mid Grey": true,
    "Espresso Brown_Midnight Blue": true,
    "Espresso Brown_Olive Green": true,
    "Espresso Brown_Orange": true,
    "Espresso Brown_Peanut Butter": true,
    "Espresso Brown_Pink": true,
    "Espresso Brown_Red": true,
    "Espresso Brown_Royal Blue": true,
    "Espresso Brown_Saddle Brown": true,
    "Espresso Brown_Sage Grey": true,
    "Espresso Brown_Sand": true,
    "Espresso Brown_Sky Blue": true,
    "Espresso Brown_Slate Blue": true,
    "Espresso Brown_Slate Grey": true,
    "Espresso Brown_Soft Plum": true,
    "Espresso Brown_Steel Blue": true,
    "Espresso Brown_Warm Khaki": true,
    "Espresso Brown_White": true,
    "Espresso Brown_Wine Red": true,
    "Golden Yellow_Golden Yellow": true,
    "Golden Yellow_Aqua Blue": true,
    "Golden Yellow_Beige": true,
    "Golden Yellow_Black": true,
    "Golden Yellow_Charcoal Grey": true,
    "Golden Yellow_Dark Mocha": true,
    "Golden Yellow_Dark Orange": true,
    "Golden Yellow_Dark Purple": true,
    "Golden Yellow_Dark Saddle Brown": true,
    "Golden Yellow_Deep Teal": true,
    "Golden Yellow_Espresso Brown": true,
    "Golden Yellow_Lavender": true,
    "Golden Yellow_Light Grey": true,
    "Golden Yellow_Lime Green": true,
    "Golden Yellow_Mid Grey": true,
    "Golden Yellow_Midnight Blue": true,
    "Golden Yellow_Olive Green": true,
    "Golden Yellow_Orange": true,
    "Golden Yellow_Peanut Butter": true,
    "Golden Yellow_Pink": true,
    "Golden Yellow_Red": true,
    "Golden Yellow_Royal Blue": true,
    "Golden Yellow_Saddle Brown": true,
    "Golden Yellow_Sage Grey": true,
    "Golden Yellow_Sand": true,
    "Golden Yellow_Sky Blue": true,
    "Golden Yellow_Slate Blue": true,
    "Golden Yellow_Slate Grey": true,
    "Golden Yellow_Soft Plum": true,
    "Golden Yellow_Steel Blue": true,
    "Golden Yellow_Warm Khaki": true,
    "Golden Yellow_White": true,
    "Golden Yellow_Wine Red": true,
    "Lavender_Lavender": true,
    "Lavender_Aqua Blue": true,
    "Lavender_Beige": true,
    "Lavender_Black": true,
    "Lavender_Charcoal Grey": true,
    "Lavender_Dark Mocha": true,
    "Lavender_Dark Orange": true,
    "Lavender_Dark Purple": true,
    "Lavender_Dark Saddle Brown": true,
    "Lavender_Deep Teal": true,
    "Lavender_Espresso Brown": true,
    "Lavender_Golden Yellow": true,
    "Lavender_Light Grey": true,
    "Lavender_Lime Green": true,
    "Lavender_Mid Grey": true,
    "Lavender_Midnight Blue": true,
    "Lavender_Olive Green": true,
    "Lavender_Orange": true,
    "Lavender_Peanut Butter": true,
    "Lavender_Pink": true,
    "Lavender_Red": true,
    "Lavender_Royal Blue": true,
    "Lavender_Saddle Brown": true,
    "Lavender_Sage Grey": true,
    "Lavender_Sand": true,
    "Lavender_Sky Blue": true,
    "Lavender_Slate Blue": true,
    "Lavender_Slate Grey": true,
    "Lavender_Soft Plum": true,
    "Lavender_Steel Blue": true,
    "Lavender_Warm Khaki": true,
    "Lavender_White": true,
    "Lavender_Wine Red": true,
    "Light Grey_Light Grey": true,
    "Light Grey_Aqua Blue": true,
    "Light Grey_Beige": true,
    "Light Grey_Black": true,
    "Light Grey_Charcoal Grey": true,
    "Light Grey_Dark Mocha": true,
    "Light Grey_Dark Orange": true,
    "Light Grey_Dark Purple": true,
    "Light Grey_Dark Saddle Brown": true,
    "Light Grey_Deep Teal": true,
    "Light Grey_Espresso Brown": true,
    "Light Grey_Golden Yellow": true,
    "Light Grey_Lavender": true,
    "Light Grey_Lime Green": true,
    "Light Grey_Mid Grey": true,
    "Light Grey_Midnight Blue": true,
    "Light Grey_Olive Green": true,
    "Light Grey_Orange": true,
    "Light Grey_Peanut Butter": true,
    "Light Grey_Pink": true,
    "Light Grey_Red": true,
    "Light Grey_Royal Blue": true,
    "Light Grey_Saddle Brown": true,
    "Light Grey_Sage Grey": true,
    "Light Grey_Sand": true,
    "Light Grey_Sky Blue": true,
    "Light Grey_Slate Blue": true,
    "Light Grey_Slate Grey": true,
    "Light Grey_Soft Plum": true,
    "Light Grey_Steel Blue": true,
    "Light Grey_Warm Khaki": true,
    "Light Grey_White": true,
    "Light Grey_Wine Red": true,
    "Lime Green_Lime Green": true,
    "Lime Green_Aqua Blue": true,
    "Lime Green_Beige": true,
    "Lime Green_Black": true,
    "Lime Green_Charcoal Grey": true,
    "Lime Green_Dark Mocha": true,
    "Lime Green_Dark Orange": true,
    "Lime Green_Dark Purple": true,
    "Lime Green_Dark Saddle Brown": true,
    "Lime Green_Deep Teal": true,
    "Lime Green_Espresso Brown": true,
    "Lime Green_Golden Yellow": true,
    "Lime Green_Lavender": true,
    "Lime Green_Light Grey": true,
    "Lime Green_Mid Grey": true,
    "Lime Green_Midnight Blue": true,
    "Lime Green_Olive Green": true,
    "Lime Green_Orange": true,
    "Lime Green_Peanut Butter": true,
    "Lime Green_Pink": true,
    "Lime Green_Red": true,
    "Lime Green_Royal Blue": true,
    "Lime Green_Saddle Brown": true,
    "Lime Green_Sage Grey": true,
    "Lime Green_Sand": true,
    "Lime Green_Sky Blue": true,
    "Lime Green_Slate Blue": true,
    "Lime Green_Slate Grey": true,
    "Lime Green_Soft Plum": true,
    "Lime Green_Steel Blue": true,
    "Lime Green_Warm Khaki": true,
    "Lime Green_White": true,
    "Lime Green_Wine Red": true,
    "Mid Grey_Mid Grey": true,
    "Mid Grey_Aqua Blue": true,
    "Mid Grey_Beige": true,
    "Mid Grey_Black": true,
    "Mid Grey_Charcoal Grey": true,
    "Mid Grey_Dark Mocha": true,
    "Mid Grey_Dark Orange": true,
    "Mid Grey_Dark Purple": true,
    "Mid Grey_Dark Saddle Brown": true,
    "Mid Grey_Deep Teal": true,
    "Mid Grey_Espresso Brown": true,
    "Mid Grey_Golden Yellow": true,
    "Mid Grey_Lavender": true,
    "Mid Grey_Light Grey": true,
    "Mid Grey_Lime Green": true,
    "Mid Grey_Midnight Blue": true,
    "Mid Grey_Olive Green": true,
    "Mid Grey_Orange": true,
    "Mid Grey_Peanut Butter": true,
    "Mid Grey_Pink": true,
    "Mid Grey_Red": true,
    "Mid Grey_Royal Blue": true,
    "Mid Grey_Saddle Brown": true,
    "Mid Grey_Sage Grey": true,
    "Mid Grey_Sand": true,
    "Mid Grey_Sky Blue": true,
    "Mid Grey_Slate Blue": true,
    "Mid Grey_Slate Grey": true,
    "Mid Grey_Soft Plum": true,
    "Mid Grey_Steel Blue": true,
    "Mid Grey_Warm Khaki": true,
    "Mid Grey_White": true,
    "Mid Grey_Wine Red": true,
    "Midnight Blue_Midnight Blue": true,
    "Midnight Blue_Aqua Blue": true,
    "Midnight Blue_Beige": true,
    "Midnight Blue_Black": true,
    "Midnight Blue_Charcoal Grey": true,
    "Midnight Blue_Dark Mocha": true,
    "Midnight Blue_Dark Orange": true,
    "Midnight Blue_Dark Purple": true,
    "Midnight Blue_Dark Saddle Brown": true,
    "Midnight Blue_Deep Teal": true,
    "Midnight Blue_Espresso Brown": true,
    "Midnight Blue_Golden Yellow": true,
    "Midnight Blue_Lavender": true,
    "Midnight Blue_Light Grey": true,
    "Midnight Blue_Lime Green": true,
    "Midnight Blue_Mid Grey": true,
    "Midnight Blue_Olive Green": true,
    "Midnight Blue_Orange": true,
    "Midnight Blue_Peanut Butter": true,
    "Midnight Blue_Pink": true,
    "Midnight Blue_Red": true,
    "Midnight Blue_Royal Blue": true,
    "Midnight Blue_Saddle Brown": true,
    "Midnight Blue_Sage Grey": true,
    "Midnight Blue_Sand": true,
    "Midnight Blue_Sky Blue": true,
    "Midnight Blue_Slate Blue": true,
    "Midnight Blue_Slate Grey": true,
    "Midnight Blue_Soft Plum": true,
    "Midnight Blue_Steel Blue": true,
    "Midnight Blue_Warm Khaki": true,
    "Midnight Blue_White": true,
    "Midnight Blue_Wine Red": true,
    "Olive Green_Olive Green": true,
    "Olive Green_Aqua Blue": true,
    "Olive Green_Beige": true,
    "Olive Green_Black": true,
    "Olive Green_Charcoal Grey": true,
    "Olive Green_Dark Mocha": true,
    "Olive Green_Dark Orange": true,
    "Olive Green_Dark Purple": true,
    "Olive Green_Dark Saddle Brown": true,
    "Olive Green_Deep Teal": true,
    "Olive Green_Espresso Brown": true,
    "Olive Green_Golden Yellow": true,
    "Olive Green_Lavender": true,
    "Olive Green_Light Grey": true,
    "Olive Green_Lime Green": true,
    "Olive Green_Mid Grey": true,
    "Olive Green_Midnight Blue": true,
    "Olive Green_Orange": true,
    "Olive Green_Peanut Butter": true,
    "Olive Green_Pink": true,
    "Olive Green_Red": true,
    "Olive Green_Royal Blue": true,
    "Olive Green_Saddle Brown": true,
    "Olive Green_Sage Grey": true,
    "Olive Green_Sand": true,
    "Olive Green_Sky Blue": true,
    "Olive Green_Slate Blue": true,
    "Olive Green_Slate Grey": true,
    "Olive Green_Soft Plum": true,
    "Olive Green_Steel Blue": true,
    "Olive Green_Warm Khaki": true,
    "Olive Green_White": true,
    "Olive Green_Wine Red": true,
    "Orange_Orange": true,
    "Orange_Aqua Blue": true,
    "Orange_Beige": true,
    "Orange_Black": true,
    "Orange_Charcoal Grey": true,
    "Orange_Dark Mocha": true,
    "Orange_Dark Orange": true,
    "Orange_Dark Purple": true,
    "Orange_Dark Saddle Brown": true,
    "Orange_Deep Teal": true,
    "Orange_Espresso Brown": true,
    "Orange_Golden Yellow": true,
    "Orange_Lavender": true,
    "Orange_Light Grey": true,
    "Orange_Lime Green": true,
    "Orange_Mid Grey": true,
    "Orange_Midnight Blue": true,
    "Orange_Olive Green": true,
    "Orange_Peanut Butter": true,
    "Orange_Pink": true,
    "Orange_Red": true,
    "Orange_Royal Blue": true,
    "Orange_Saddle Brown": true,
    "Orange_Sage Grey": true,
    "Orange_Sand": true,
    "Orange_Sky Blue": true,
    "Orange_Slate Blue": true,
    "Orange_Slate Grey": true,
    "Orange_Soft Plum": true,
    "Orange_Steel Blue": true,
    "Orange_Warm Khaki": true,
    "Orange_White": true,
    "Orange_Wine Red": true,
    "Peanut Butter_Peanut Butter": true,
    "Peanut Butter_Aqua Blue": true,
    "Peanut Butter_Beige": true,
    "Peanut Butter_Black": true,
    "Peanut Butter_Charcoal Grey": true,
    "Peanut Butter_Dark Mocha": true,
    "Peanut Butter_Dark Orange": true,
    "Peanut Butter_Dark Purple": true,
    "Peanut Butter_Dark Saddle Brown": true,
    "Peanut Butter_Deep Teal": true,
    "Peanut Butter_Espresso Brown": true,
    "Peanut Butter_Golden Yellow": true,
    "Peanut Butter_Lavender": true,
    "Peanut Butter_Light Grey": true,
    "Peanut Butter_Lime Green": true,
    "Peanut Butter_Mid Grey": true,
    "Peanut Butter_Midnight Blue": true,
    "Peanut Butter_Olive Green": true,
    "Peanut Butter_Orange": true,
    "Peanut Butter_Pink": true,
    "Peanut Butter_Red": true,
    "Peanut Butter_Royal Blue": true,
    "Peanut Butter_Saddle Brown": true,
    "Peanut Butter_Sage Grey": true,
    "Peanut Butter_Sand": true,
    "Peanut Butter_Sky Blue": true,
    "Peanut Butter_Slate Blue": true,
    "Peanut Butter_Slate Grey": true,
    "Peanut Butter_Soft Plum": true,
    "Peanut Butter_Steel Blue": true,
    "Peanut Butter_Warm Khaki": true,
    "Peanut Butter_White": true,
    "Peanut Butter_Wine Red": true,
    "Pink_Pink": true,
    "Pink_Aqua Blue": true,
    "Pink_Beige": true,
    "Pink_Black": true,
    "Pink_Charcoal Grey": true,
    "Pink_Dark Mocha": true,
    "Pink_Dark Orange": true,
    "Pink_Dark Purple": true,
    "Pink_Dark Saddle Brown": true,
    "Pink_Deep Teal": true,
    "Pink_Espresso Brown": true,
    "Pink_Golden Yellow": true,
    "Pink_Lavender": true,
    "Pink_Light Grey": true,
    "Pink_Lime Green": true,
    "Pink_Mid Grey": true,
    "Pink_Midnight Blue": true,
    "Pink_Olive Green": true,
    "Pink_Orange": true,
    "Pink_Peanut Butter": true,
    "Pink_Red": true,
    "Pink_Royal Blue": true,
    "Pink_Saddle Brown": true,
    "Pink_Sage Grey": true,
    "Pink_Sand": true,
    "Pink_Sky Blue": true,
    "Pink_Slate Blue": true,
    "Pink_Slate Grey": true,
    "Pink_Soft Plum": true,
    "Pink_Steel Blue": true,
    "Pink_Warm Khaki": true,
    "Pink_White": true,
    "Pink_Wine Red": true,
    "Red_Red": true,
    "Red_Aqua Blue": true,
    "Red_Beige": true,
    "Red_Black": true,
    "Red_Charcoal Grey": true,
    "Red_Dark Mocha": true,
    "Red_Dark Orange": true,
    "Red_Dark Purple": true,
    "Red_Dark Saddle Brown": true,
    "Red_Deep Teal": true,
    "Red_Espresso Brown": true,
    "Red_Golden Yellow": true,
    "Red_Lavender": true,
    "Red_Light Grey": true,
    "Red_Lime Green": true,
    "Red_Mid Grey": true,
    "Red_Midnight Blue": true,
    "Red_Olive Green": true,
    "Red_Orange": true,
    "Red_Peanut Butter": true,
    "Red_Pink": true,
    "Red_Royal Blue": true,
    "Red_Saddle Brown": true,
    "Red_Sage Grey": true,
    "Red_Sand": true,
    "Red_Sky Blue": true,
    "Red_Slate Blue": true,
    "Red_Slate Grey": true,
    "Red_Soft Plum": true,
    "Red_Steel Blue": true,
    "Red_Warm Khaki": true,
    "Red_White": true,
    "Red_Wine Red": true,
    "Royal Blue_Royal Blue": true,
    "Royal Blue_Aqua Blue": true,
    "Royal Blue_Beige": true,
    "Royal Blue_Black": true,
    "Royal Blue_Charcoal Grey": true,
    "Royal Blue_Dark Mocha": true,
    "Royal Blue_Dark Orange": true,
    "Royal Blue_Dark Purple": true,
    "Royal Blue_Dark Saddle Brown": true,
    "Royal Blue_Deep Teal": true,
    "Royal Blue_Espresso Brown": true,
    "Royal Blue_Golden Yellow": true,
    "Royal Blue_Lavender": true,
    "Royal Blue_Light Grey": true,
    "Royal Blue_Lime Green": true,
    "Royal Blue_Mid Grey": true,
    "Royal Blue_Midnight Blue": true,
    "Royal Blue_Olive Green": true,
    "Royal Blue_Orange": true,
    "Royal Blue_Peanut Butter": true,
    "Royal Blue_Pink": true,
    "Royal Blue_Red": true,
    "Royal Blue_Saddle Brown": true,
    "Royal Blue_Sage Grey": true,
    "Royal Blue_Sand": true,
    "Royal Blue_Sky Blue": true,
    "Royal Blue_Slate Blue": true,
    "Royal Blue_Slate Grey": true,
    "Royal Blue_Soft Plum": true,
    "Royal Blue_Steel Blue": true,
    "Royal Blue_Warm Khaki": true,
    "Royal Blue_White": true,
    "Royal Blue_Wine Red": true,
    "Saddle Brown_Saddle Brown": true,
    "Saddle Brown_Aqua Blue": true,
    "Saddle Brown_Beige": true,
    "Saddle Brown_Black": true,
    "Saddle Brown_Charcoal Grey": true,
    "Saddle Brown_Dark Mocha": true,
    "Saddle Brown_Dark Orange": true,
    "Saddle Brown_Dark Purple": true,
    "Saddle Brown_Dark Saddle Brown": true,
    "Saddle Brown_Deep Teal": true,
    "Saddle Brown_Espresso Brown": true,
    "Saddle Brown_Golden Yellow": true,
    "Saddle Brown_Lavender": true,
    "Saddle Brown_Light Grey": true,
    "Saddle Brown_Lime Green": true,
    "Saddle Brown_Mid Grey": true,
    "Saddle Brown_Midnight Blue": true,
    "Saddle Brown_Olive Green": true,
    "Saddle Brown_Orange": true,
    "Saddle Brown_Peanut Butter": true,
    "Saddle Brown_Pink": true,
    "Saddle Brown_Red": true,
    "Saddle Brown_Royal Blue": true,
    "Saddle Brown_Sage Grey": true,
    "Saddle Brown_Sand": true,
    "Saddle Brown_Sky Blue": true,
    "Saddle Brown_Slate Blue": true,
    "Saddle Brown_Slate Grey": true,
    "Saddle Brown_Soft Plum": true,
    "Saddle Brown_Steel Blue": true,
    "Saddle Brown_Warm Khaki": true,
    "Saddle Brown_White": true,
    "Saddle Brown_Wine Red": true,
    "Sage Grey_Sage Grey": true,
    "Sage Grey_Aqua Blue": true,
    "Sage Grey_Beige": true,
    "Sage Grey_Black": true,
    "Sage Grey_Charcoal Grey": true,
    "Sage Grey_Dark Mocha": true,
    "Sage Grey_Dark Orange": true,
    "Sage Grey_Dark Purple": true,
    "Sage Grey_Dark Saddle Brown": true,
    "Sage Grey_Deep Teal": true,
    "Sage Grey_Espresso Brown": true,
    "Sage Grey_Golden Yellow": true,
    "Sage Grey_Lavender": true,
    "Sage Grey_Light Grey": true,
    "Sage Grey_Lime Green": true,
    "Sage Grey_Mid Grey": true,
    "Sage Grey_Midnight Blue": true,
    "Sage Grey_Olive Green": true,
    "Sage Grey_Orange": true,
    "Sage Grey_Peanut Butter": true,
    "Sage Grey_Pink": true,
    "Sage Grey_Red": true,
    "Sage Grey_Royal Blue": true,
    "Sage Grey_Saddle Brown": true,
    "Sage Grey_Sand": true,
    "Sage Grey_Sky Blue": true,
    "Sage Grey_Slate Blue": true,
    "Sage Grey_Slate Grey": true,
    "Sage Grey_Soft Plum": true,
    "Sage Grey_Steel Blue": true,
    "Sage Grey_Warm Khaki": true,
    "Sage Grey_White": true,
    "Sage Grey_Wine Red": true,
    "Sand_Sand": true,
    "Sand_Aqua Blue": true,
    "Sand_Beige": true,
    "Sand_Black": true,
    "Sand_Charcoal Grey": true,
    "Sand_Dark Mocha": true,
    "Sand_Dark Orange": true,
    "Sand_Dark Purple": true,
    "Sand_Dark Saddle Brown": true,
    "Sand_Deep Teal": true,
    "Sand_Espresso Brown": true,
    "Sand_Golden Yellow": true,
    "Sand_Lavender": true,
    "Sand_Light Grey": true,
    "Sand_Lime Green": true,
    "Sand_Mid Grey": true,
    "Sand_Midnight Blue": true,
    "Sand_Olive Green": true,
    "Sand_Orange": true,
    "Sand_Peanut Butter": true,
    "Sand_Pink": true,
    "Sand_Red": true,
    "Sand_Royal Blue": true,
    "Sand_Saddle Brown": true,
    "Sand_Sage Grey": true,
    "Sand_Sky Blue": true,
    "Sand_Slate Blue": true,
    "Sand_Slate Grey": true,
    "Sand_Soft Plum": true,
    "Sand_Steel Blue": true,
    "Sand_Warm Khaki": true,
    "Sand_White": true,
    "Sand_Wine Red": true,
    "Sky Blue_Sky Blue": true,
    "Sky Blue_Aqua Blue": true,
    "Sky Blue_Beige": true,
    "Sky Blue_Black": true,
    "Sky Blue_Charcoal Grey": true,
    "Sky Blue_Dark Mocha": true,
    "Sky Blue_Dark Orange": true,
    "Sky Blue_Dark Purple": true,
    "Sky Blue_Dark Saddle Brown": true,
    "Sky Blue_Deep Teal": true,
    "Sky Blue_Espresso Brown": true,
    "Sky Blue_Golden Yellow": true,
    "Sky Blue_Lavender": true,
    "Sky Blue_Light Grey": true,
    "Sky Blue_Lime Green": true,
    "Sky Blue_Mid Grey": true,
    "Sky Blue_Midnight Blue": true,
    "Sky Blue_Olive Green": true,
    "Sky Blue_Orange": true,
    "Sky Blue_Peanut Butter": true,
    "Sky Blue_Pink": true,
    "Sky Blue_Red": true,
    "Sky Blue_Royal Blue": true,
    "Sky Blue_Saddle Brown": true,
    "Sky Blue_Sage Grey": true,
    "Sky Blue_Sand": true,
    "Sky Blue_Slate Blue": true,
    "Sky Blue_Slate Grey": true,
    "Sky Blue_Soft Plum": true,
    "Sky Blue_Steel Blue": true,
    "Sky Blue_Warm Khaki": true,
    "Sky Blue_White": true,
    "Sky Blue_Wine Red": true,
    "Slate Blue_Slate Blue": true,
    "Slate Blue_Aqua Blue": true,
    "Slate Blue_Beige": true,
    "Slate Blue_Black": true,
    "Slate Blue_Charcoal Grey": true,
    "Slate Blue_Dark Mocha": true,
    "Slate Blue_Dark Orange": true,
    "Slate Blue_Dark Purple": true,
    "Slate Blue_Dark Saddle Brown": true,
    "Slate Blue_Deep Teal": true,
    "Slate Blue_Espresso Brown": true,
    "Slate Blue_Golden Yellow": true,
    "Slate Blue_Lavender": true,
    "Slate Blue_Light Grey": true,
    "Slate Blue_Lime Green": true,
    "Slate Blue_Mid Grey": true,
    "Slate Blue_Midnight Blue": true,
    "Slate Blue_Olive Green": true,
    "Slate Blue_Orange": true,
    "Slate Blue_Peanut Butter": true,
    "Slate Blue_Pink": true,
    "Slate Blue_Red": true,
    "Slate Blue_Royal Blue": true,
    "Slate Blue_Saddle Brown": true,
    "Slate Blue_Sage Grey": true,
    "Slate Blue_Sand": true,
    "Slate Blue_Sky Blue": true,
    "Slate Blue_Slate Grey": true,
    "Slate Blue_Soft Plum": true,
    "Slate Blue_Steel Blue": true,
    "Slate Blue_Warm Khaki": true,
    "Slate Blue_White": true,
    "Slate Blue_Wine Red": true,
    "Slate Grey_Slate Grey": true,
    "Slate Grey_Aqua Blue": true,
    "Slate Grey_Beige": true,
    "Slate Grey_Black": true,
    "Slate Grey_Charcoal Grey": true,
    "Slate Grey_Dark Mocha": true,
    "Slate Grey_Dark Orange": true,
    "Slate Grey_Dark Purple": true,
    "Slate Grey_Dark Saddle Brown": true,
    "Slate Grey_Deep Teal": true,
    "Slate Grey_Espresso Brown": true,
    "Slate Grey_Golden Yellow": true,
    "Slate Grey_Lavender": true,
    "Slate Grey_Light Grey": true,
    "Slate Grey_Lime Green": true,
    "Slate Grey_Mid Grey": true,
    "Slate Grey_Midnight Blue": true,
    "Slate Grey_Olive Green": true,
    "Slate Grey_Orange": true,
    "Slate Grey_Peanut Butter": true,
    "Slate Grey_Pink": true,
    "Slate Grey_Red": true,
    "Slate Grey_Royal Blue": true,
    "Slate Grey_Saddle Brown": true,
    "Slate Grey_Sage Grey": true,
    "Slate Grey_Sand": true,
    "Slate Grey_Sky Blue": true,
    "Slate Grey_Slate Blue": true,
    "Slate Grey_Soft Plum": true,
    "Slate Grey_Steel Blue": true,
    "Slate Grey_Warm Khaki": true,
    "Slate Grey_White": true,
    "Slate Grey_Wine Red": true,
    "Soft Plum_Soft Plum": true,
    "Soft Plum_Aqua Blue": true,
    "Soft Plum_Beige": true,
    "Soft Plum_Black": true,
    "Soft Plum_Charcoal Grey": true,
    "Soft Plum_Dark Mocha": true,
    "Soft Plum_Dark Orange": true,
    "Soft Plum_Dark Purple": true,
    "Soft Plum_Dark Saddle Brown": true,
    "Soft Plum_Deep Teal": true,
    "Soft Plum_Espresso Brown": true,
    "Soft Plum_Golden Yellow": true,
    "Soft Plum_Lavender": true,
    "Soft Plum_Light Grey": true,
    "Soft Plum_Lime Green": true,
    "Soft Plum_Mid Grey": true,
    "Soft Plum_Midnight Blue": true,
    "Soft Plum_Olive Green": true,
    "Soft Plum_Orange": true,
    "Soft Plum_Peanut Butter": true,
    "Soft Plum_Pink": true,
    "Soft Plum_Red": true,
    "Soft Plum_Royal Blue": true,
    "Soft Plum_Saddle Brown": true,
    "Soft Plum_Sage Grey": true,
    "Soft Plum_Sand": true,
    "Soft Plum_Sky Blue": true,
    "Soft Plum_Slate Blue": true,
    "Soft Plum_Slate Grey": true,
    "Soft Plum_Steel Blue": true,
    "Soft Plum_Warm Khaki": true,
    "Soft Plum_White": true,
    "Soft Plum_Wine Red": true,
    "Steel Blue_Steel Blue": true,
    "Steel Blue_Aqua Blue": true,
    "Steel Blue_Beige": true,
    "Steel Blue_Black": true,
    "Steel Blue_Charcoal Grey": true,
    "Steel Blue_Dark Mocha": true,
    "Steel Blue_Dark Orange": true,
    "Steel Blue_Dark Purple": true,
    "Steel Blue_Dark Saddle Brown": true,
    "Steel Blue_Deep Teal": true,
    "Steel Blue_Espresso Brown": true,
    "Steel Blue_Golden Yellow": true,
    "Steel Blue_Lavender": true,
    "Steel Blue_Light Grey": true,
    "Steel Blue_Lime Green": true,
    "Steel Blue_Mid Grey": true,
    "Steel Blue_Midnight Blue": true,
    "Steel Blue_Olive Green": true,
    "Steel Blue_Orange": true,
    "Steel Blue_Peanut Butter": true,
    "Steel Blue_Pink": true,
    "Steel Blue_Red": true,
    "Steel Blue_Royal Blue": true,
    "Steel Blue_Saddle Brown": true,
    "Steel Blue_Sage Grey": true,
    "Steel Blue_Sand": true,
    "Steel Blue_Sky Blue": true,
    "Steel Blue_Slate Blue": true,
    "Steel Blue_Slate Grey": true,
    "Steel Blue_Soft Plum": true,
    "Steel Blue_Warm Khaki": true,
    "Steel Blue_White": true,
    "Steel Blue_Wine Red": true,
    "Warm Khaki_Warm Khaki": true,
    "Warm Khaki_Aqua Blue": true,
    "Warm Khaki_Beige": true,
    "Warm Khaki_Black": true,
    "Warm Khaki_Charcoal Grey": true,
    "Warm Khaki_Dark Mocha": true,
    "Warm Khaki_Dark Orange": true,
    "Warm Khaki_Dark Purple": true,
    "Warm Khaki_Dark Saddle Brown": true,
    "Warm Khaki_Deep Teal": true,
    "Warm Khaki_Espresso Brown": true,
    "Warm Khaki_Golden Yellow": true,
    "Warm Khaki_Lavender": true,
    "Warm Khaki_Light Grey": true,
    "Warm Khaki_Lime Green": true,
    "Warm Khaki_Mid Grey": true,
    "Warm Khaki_Midnight Blue": true,
    "Warm Khaki_Olive Green": true,
    "Warm Khaki_Orange": true,
    "Warm Khaki_Peanut Butter": true,
    "Warm Khaki_Pink": true,
    "Warm Khaki_Red": true,
    "Warm Khaki_Royal Blue": true,
    "Warm Khaki_Saddle Brown": true,
    "Warm Khaki_Sage Grey": true,
    "Warm Khaki_Sand": true,
    "Warm Khaki_Sky Blue": true,
    "Warm Khaki_Slate Blue": true,
    "Warm Khaki_Slate Grey": true,
    "Warm Khaki_Soft Plum": true,
    "Warm Khaki_Steel Blue": true,
    "Warm Khaki_White": true,
    "Warm Khaki_Wine Red": true,
    "White_White": true,
    "White_Aqua Blue": true,
    "White_Beige": true,
    "White_Black": true,
    "White_Charcoal Grey": true,
    "White_Dark Mocha": true,
    "White_Dark Orange": true,
    "White_Dark Purple": true,
    "White_Dark Saddle Brown": true,
    "White_Deep Teal": true,
    "White_Espresso Brown": true,
    "White_Golden Yellow": true,
    "White_Lavender": true,
    "White_Light Grey": true,
    "White_Lime Green": true,
    "White_Mid Grey": true,
    "White_Midnight Blue": true,
    "White_Olive Green": true,
    "White_Orange": true,
    "White_Peanut Butter": true,
    "White_Pink": true,
    "White_Red": true,
    "White_Royal Blue": true,
    "White_Saddle Brown": true,
    "White_Sage Grey": true,
    "White_Sand": true,
    "White_Sky Blue": true,
    "White_Slate Blue": true,
    "White_Slate Grey": true,
    "White_Soft Plum": true,
    "White_Steel Blue": true,
    "White_Warm Khaki": true,
    "White_Wine Red": true,
    "Wine Red_Wine Red": true,
    "Wine Red_Aqua Blue": true,
    "Wine Red_Beige": true,
    "Wine Red_Black": true,
    "Wine Red_Charcoal Grey": true,
    "Wine Red_Dark Mocha": true,
    "Wine Red_Dark Orange": true,
    "Wine Red_Dark Purple": true,
    "Wine Red_Dark Saddle Brown": true,
    "Wine Red_Deep Teal": true,
    "Wine Red_Espresso Brown": true,
    "Wine Red_Golden Yellow": true,
    "Wine Red_Lavender": true,
    "Wine Red_Light Grey": true,
    "Wine Red_Lime Green": true,
    "Wine Red_Mid Grey": true,
    "Wine Red_Midnight Blue": true,
    "Wine Red_Olive Green": true,
    "Wine Red_Orange": true,
    "Wine Red_Peanut Butter": true,
    "Wine Red_Pink": true,
    "Wine Red_Red": true,
    "Wine Red_Royal Blue": true,
    "Wine Red_Saddle Brown": true,
    "Wine Red_Sage Grey": true,
    "Wine Red_Sand": true,
    "Wine Red_Sky Blue": true,
    "Wine Red_Slate Blue": true,
    "Wine Red_Slate Grey": true,
    "Wine Red_Soft Plum": true,
    "Wine Red_Steel Blue": true,
    "Wine Red_Warm Khaki": true,
    "Wine Red_White": true
   },
   "count": 1089
  },
  "Diamond": {
   "available": {
    "Aqua Blue_Aqua Blue": true,
    "Aqua Blue_Beige": true,
    "Aqua Blue_Black": true,
    "Aqua Blue_Charcoal Grey": true,
    "Aqua Blue_Dark Mocha": true,
    "Aqua Blue_Dark Orange": true,
    "Aqua Blue_Dark Purple": true,
    "Aqua Blue_Dark Saddle Brown": true,
    "Aqua Blue_Deep Teal": true,
    "Aqua Blue_Espresso Brown": true,
    "Aqua Blue_Golden Yellow": true,
    "Aqua Blue_Lavender": true,
    "Aqua Blue_Light Grey": true,
    "Aqua Blue_Lime Green": true,
    "Aqua Blue_Mid Grey": true,
    "Aqua Blue_Midnight Blue": true,
    "Aqua Blue_Olive Green": true,
    "Aqua Blue_Orange": true,
    "Aqua Blue_Peanut Butter": true,
    "Aqua Blue_Pink": true,
    "Aqua Blue_Red": true,
    "Aqua Blue_Royal Blue": true,
    "Aqua Blue_Saddle Brown": true,
    "Aqua Blue_Sage Grey": true,
    "Aqua Blue_Sand": true,
    "Aqua Blue_Sky Blue": true,
    "Aqua Blue_Slate Blue": true,
    "Aqua Blue_Slate Grey": true,
    "Aqua Blue_Soft Plum": true,
    "Aqua Blue_Steel Blue": true,
    "Aqua Blue_Warm Khaki": true,
    "Aqua Blue_White": true,
    "Aqua Blue_Wine Red": true,
    "Beige_Beige": true,
    "Beige_Aqua Blue": true,
    "Beige_Black": true,
    "Beige_Charcoal Grey": true,
    "Beige_Dark Mocha": true,
    "Beige_Dark Orange": true,
    "Beige_Dark Purple": true,
    "Beige_Dark Saddle Brown": true,
    "Beige_Deep Teal": true,
    "Beige_Espresso Brown": true,
    "Beige_Golden Yellow": true,
    "Beige_Lavender": true,
    "Beige_Light Grey": true,
    "Beige_Lime Green": true,
    "Beige_Mid Grey": true,
    "Beige_Midnight Blue": true,
    "Beige_Olive Green": true,
    "Beige_Orange": true,
    "Beige_Peanut Butter": true,
    "Beige_Pink": true,
    "Beige_Red": true,
    "Beige_Royal Blue": true,
    "Beige_Saddle Brown": true,
    "Beige_Sage Grey": true,
    "Beige_Sand": true,
    "Beige_Sky Blue": true,
    "Beige_Slate Blue": true,
    "Beige_Slate Grey": true,
    "Beige_Soft Plum": true,
    "Beige_Steel Blue": true,
    "Beige_Warm Khaki": true,
    "Beige_White": true,
    "Beige_Wine Red": true,
    "Black_Black": true,
    "Black_Aqua Blue": true,
    "Black_Beige": true,
    "Black_Charcoal Grey": true,
    "Black_Dark Mocha": true,
    "Black_Dark Orange": true,
    "Black_Dark Purple": true,
    "Black_Dark Saddle Brown": true,
    "Black_Deep Teal": true,
    "Black_Espresso Brown": true,
    "Black_Golden Yellow": true,
    "Black_Lavender": true,
    "Black_Light Grey": true,
    "Black_Lime Green": true,
    "Black_Mid Grey": true,
    "Black_Midnight Blue": true,
    "Black_Olive Green": true,
    "Black_Orange": true,
    "Black_Peanut Butter": true,
    "Black_Pink": true,
    "Black_Red": true,
    "Black_Royal Blue": true,
    "Black_Saddle Brown": true,
    "Black_Sage Grey": true,
    "Black_Sand": true,
    "Black_Sky Blue": true,
    "Black_Slate Blue": true,
    "Black_Slate Grey": true,
    "Black_Soft Plum": true,
    "Black_Steel Blue": true,
    "Black_Warm Khaki": true,
    "Black_White": true,
    "Black_Wine Red": true,
    "Charcoal Grey_Charcoal Grey": true,
    "Charcoal Grey_Aqua Blue": true,
    "Charcoal Grey_Beige": true,
    "Charcoal Grey_Black": true,
    "Charcoal Grey_Dark Mocha": true,
    "Charcoal Grey_Dark Orange": true,
    "Charcoal Grey_Dark Purple": true,
    "Charcoal Grey_Dark Saddle Brown": true,
    "Charcoal Grey_Deep Teal": true,
    "Charcoal Grey_Espresso Brown": true,
    "Charcoal Grey_Golden Yellow": true,
    "Charcoal Grey_Lavender": true,
    "Charcoal Grey_Light Grey": true,
    "Charcoal Grey_Lime Green": true,
    "Charcoal Grey_Mid Grey": true,
    "Charcoal Grey_Midnight Blue": true,
    "Charcoal Grey_Olive Green": true,
    "Charcoal Grey_Orange": true,
    "Charcoal Grey_Peanut Butter": true,
    "Charcoal Grey_Pink": true,
    "Charcoal Grey_Red": true,
    "Charcoal Grey_Royal Blue": true,
    "Charcoal Grey_Saddle Brown": true,
    "Charcoal Grey_Sage Grey": true,
    "Charcoal Grey_Sand": true,
    "Charcoal Grey_Sky Blue": true,
    "Charcoal Grey_Slate Blue": true,
    "Charcoal Grey_Slate Grey": true,
    "Charcoal Grey_Soft Plum": true,
    "Charcoal Grey_Steel Blue": true,
    "Charcoal Grey_Warm Khaki": true,
    "Charcoal Grey_White": true,
    "Charcoal Grey_Wine Red": true,
    "Dark Mocha_Dark Mocha": true,
    "Dark Mocha_Aqua Blue": true,
    "Dark Mocha_Beige": true,
    "Dark Mocha_Black": true,
    "Dark Mocha_Charcoal Grey": true,
    "Dark Mocha_Dark Orange": true,
    "Dark Mocha_Dark Purple": true,
    "Dark Mocha_Dark Saddle Brown": true,
    "Dark Mocha_Deep Teal": true,
    "Dark Mocha_Espresso Brown": true,
    "Dark Mocha_Golden Yellow": true,
    "Dark Mocha_Lavender": true,
    "Dark Mocha_Light Grey": true,
    "Dark Mocha_Lime Green": true,
    "Dark Mocha_Mid Grey": true,
    "Dark Mocha_Midnight Blue": true,
    "Dark Mocha_Olive Green": true,
    "Dark Mocha_Orange": true,
    "Dark Mocha_Peanut Butter": true,
    "Dark Mocha_Pink": true,
    "Dark Mocha_Red": true,
    "Dark Mocha_Royal Blue": true,
    "Dark Mocha_Saddle Brown": true,
    "Dark Mocha_Sage Grey": true,
    "Dark Mocha_Sand": true,
    "Dark Mocha_Sky Blue": true,
    "Dark Mocha_Slate Blue": true,
    "Dark Mocha_Slate Grey": true,
    "Dark Mocha_Soft Plum": true,
    "Dark Mocha_Steel Blue": true,
    "Dark Mocha_Warm Khaki": true,
    "Dark Mocha_White": true,
    "Dark Mocha_Wine Red": true,
    "Dark Orange_Dark Orange": true,
    "Dark Orange_Aqua Blue": true,
    "Dark Orange_Beige": true,
    "Dark Orange_Black": true,
    "Dark Orange_Charcoal Grey": true,
    "Dark Orange_Dark Mocha": true,
    "Dark Orange_Dark Purple": true,
    "Dark Orange_Dark Saddle Brown": true,
    "Dark Orange_Deep Teal": true,
    "Dark Orange_Espresso Brown": true,
    "Dark Orange_Golden Yellow": true,
    "Dark Orange_Lavender": true,
    "Dark Orange_Light Grey": true,
    "Dark Orange_Lime Green": true,
    "Dark Orange_Mid Grey": true,
    "Dark Orange_Midnight Blue": true,
    "Dark Orange_Olive Green": true,
    "Dark Orange_Orange": true,
    "Dark Orange_Peanut Butter": true,
    "Dark Orange_Pink": true,
    "Dark Orange_Red": true,
    "Dark Orange_Royal Blue": true,
    "Dark Orange_Saddle Brown": true,
    "Dark Orange_Sage Grey": true,
    "Dark Orange_Sand": true,
    "Dark Orange_Sky Blue": true,
    "Dark Orange_Slate Blue": true,
    "Dark Orange_Slate Grey": true,
    "Dark Orange_Soft Plum": true,
    "Dark Orange_Steel Blue": true,
    "Dark Orange_Warm Khaki": true,
    "Dark Orange_White": true,
    "Dark Orange_Wine Red": true,
    "Dark Purple_Dark Purple": true,
    "Dark Purple_Aqua Blue": true,
    "Dark Purple_Beige": true,
    "Dark Purple_Black": true,
    "Dark Purple_Charcoal Grey": true,
    "Dark Purple_Dark Mocha": true,
    "Dark Purple_Dark Orange": true,
    "Dark Purple_Dark Saddle Brown": true,
    "Dark Purple_Deep Teal": true,
    "Dark Purple_Espresso Brown": true,
    "Dark Purple_Golden Yellow": true,
    "Dark Purple_Lavender": true,
    "Dark Purple_Light Grey": true,
    "Dark Purple_Lime Green": true,
    "Dark Purple_Mid Grey": true,
    "Dark Purple_Midnight Blue": true,
    "Dark Purple_Olive Green": true,
    "Dark Purple_Orange": true,
    "Dark Purple_Peanut Butter": true,
    "Dark Purple_Pink": true,
    "Dark Purple_Red": true,
    "Dark Purple_Royal Blue": true,
    "Dark Purple_Saddle Brown": true,
    "Dark Purple_Sage Grey": true,
    "Dark Purple_Sand": true,
    "Dark Purple_Sky Blue": true,
    "Dark Purple_Slate Blue": true,
    "Dark Purple_Slate Grey": true,
    "Dark Purple_Soft Plum": true,
    "Dark Purple_Steel Blue": true,
    "Dark Purple_Warm Khaki": true,
    "Dark Purple_White": true,
    "Dark Purple_Wine Red": true,
    "Dark Saddle Brown_Dark Saddle Brown": true,
    "Dark Saddle Brown_Aqua Blue": true,
    "Dark Saddle Brown_Beige": true,
    "Dark Saddle Brown_Black": true,
    "Dark Saddle Brown_Charcoal Grey": true,
    "Dark Saddle Brown_Dark Mocha": true,
    "Dark Saddle Brown_Dark Orange": true,
    "Dark Saddle Brown_Dark Purple": true,
    "Dark Saddle Brown_Deep Teal": true,
    "Dark Saddle Brown_Espresso Brown": true,
    "Dark Saddle Brown_Golden Yellow": true,
    "Dark Saddle Brown_Lavender": true,
    "Dark Saddle Brown_Light Grey": true,
    "Dark Saddle Brown_Lime Green": true,
    "Dark Saddle Brown_Mid Grey": true,
    "Dark Saddle Brown_Midnight Blue": true,
    "Dark Saddle Brown_Olive Green": true,
    "Dark Saddle Brown_Orange": true,
    "Dark Saddle Brown_Peanut Butter": true,
    "Dark Saddle Brown_Pink": true,
    "Dark Saddle Brown_Red": true,
    "Dark Saddle Brown_Royal Blue": true,
    "Dark Saddle Brown_Saddle Brown": true,
    "Dark Saddle Brown_Sage Grey": true,
    "Dark Saddle Brown_Sand": true,
    "Dark Saddle Brown_Sky Blue": true,
    "Dark Saddle Brown_Slate Blue": true,
    "Dark Saddle Brown_Slate Grey": true,
    "Dark Saddle Brown_Soft Plum": true,
    "Dark Saddle Brown_Steel Blue": true,
    "Dark Saddle Brown_Warm Khaki": true,
    "Dark Saddle Brown_White": true,
    "Dark Saddle Brown_Wine Red": true,
    "Deep Teal_Deep Teal": true,
    "Deep Teal_Aqua Blue": true,
    "Deep Teal_Beige": true,
    "Deep Teal_Black": true,
    "Deep Teal_Charcoal Grey": true,
    "Deep Teal_Dark Mocha": true,
    "Deep Teal_Dark Orange": true,
    "Deep Teal_Dark Purple": true,
    "Deep Teal_Dark Saddle Brown": true,
    "Deep Teal_Espresso Brown": true,
    "Deep Teal_Golden Yellow": true,
    "Deep Teal_Lavender": true,
    "Deep Teal_Light Grey": true,
    "Deep Teal_Lime Green": true,
    "Deep Teal_Mid Grey": true,
    "Deep Teal_Midnight Blue": true,
    "Deep Teal_Olive Green": true,
    "Deep Teal_Orange": true,
    "Deep Teal_Peanut Butter": true,
    "Deep Teal_Pink": true,
    "Deep Teal_Red": true,
    "Deep Teal_Royal Blue": true,
    "Deep Teal_Saddle Brown": true,
    "Deep Teal_Sage Grey": true,
    "Deep Teal_Sand": true,
    "Deep Teal_Sky Blue": true,
    "Deep Teal_Slate Blue": true,
    "Deep Teal_Slate Grey": true,
    "Deep Teal_Soft Plum": true,
    "Deep Teal_Steel Blue": true,
    "Deep Teal_Warm Khaki": true,
    "Deep Teal_White": true,
    "Deep Teal_Wine Red": true,
    "Espresso Brown_Espresso Brown": true,
    "Espresso Brown_Aqua Blue": true,
    "Espresso Brown_Beige": true,
    "Espresso Brown_Black": true,
    "Espresso Brown_Charcoal Grey": true,
    "Espresso Brown_Dark Mocha": true,
    "Espresso Brown_Dark Orange": true,
    "Espresso Brown_Dark Purple": true,
    "Espresso Brown_Dark Saddle Brown": true,
    "Espresso Brown_Deep Teal": true,
    "Espresso Brown_Golden Yellow": true,
    "Espresso Brown_Lavender": true,
    "Espresso Brown_Light Grey": true,
    "Espresso Brown_Lime Green": true,
    "Espresso Brown_Mid Grey": true,
    "Espresso Brown_Midnight Blue": true,
    "Espresso Brown_Olive Green": true,
    "Espresso Brown_Orange": true,
    "Espresso Brown_Peanut Butter": true,
    "Espresso Brown_Pink": true,
    "Espresso Brown_Red": true,
    "Espresso Brown_Royal Blue": true,
    "Espresso Brown_Saddle Brown": true,
    "Espresso Brown_Sage Grey": true,
    "Espresso Brown_Sand": true,
    "Espresso Brown_Sky Blue": true,
    "Espresso Brown_Slate Blue": true,
    "Espresso Brown_Slate Grey": true,
    "Espresso Brown_Soft Plum": true,
    "Espresso Brown_Steel Blue": true,
    "Espresso Brown_Warm Khaki": true,
    "Espresso Brown_White": true,
    "Espresso Brown_Wine Red": true,
    "Golden Yellow_Golden Yellow": true,
    "Golden Yellow_Aqua Blue": true,
    "Golden Yellow_Beige": true,
    "Golden Yellow_Black": true,
    "Golden Yellow_Charcoal Grey": true,
    "Golden Yellow_Dark Mocha": true,
    "Golden Yellow_Dark Orange": true,
    "Golden Yellow_Dark Purple": true,
    "Golden Yellow_Dark Saddle Brown": true,
    "Golden Yellow_Deep Teal": true,
    "Golden Yellow_Espresso Brown": true,
    "Golden Yellow_Lavender": true,
    "Golden Yellow_Light Grey": true,
    "Golden Yellow_Lime Green": true,
    "Golden Yellow_Mid Grey": true,
    "Golden Yellow_Midnight Blue": true,
    "Golden Yellow_Olive Green": true,
    "Golden Yellow_Orange": true,
    "Golden Yellow_Peanut Butter": true,
    "Golden Yellow_Pink": true,
    "Golden Yellow_Red": true,
    "Golden Yellow_Royal Blue": true,
    "Golden Yellow_Saddle Brown": true,
    "Golden Yellow_Sage Grey": true,
    "Golden Yellow_Sand": true,
    "Golden Yellow_Sky Blue": true,
    "Golden Yellow_Slate Blue": true,
    "Golden Yellow_Slate Grey": true,
    "Golden Yellow_Soft Plum": true,
    "Golden Yellow_Steel Blue": true,
    "Golden Yellow_Warm Khaki": true,
    "Golden Yellow_White": true,
    "Golden Yellow_Wine Red": true,
    "Lavender_Lavender": true,
    "Lavender_Aqua Blue": true,
    "Lavender_Beige": true,
    "Lavender_Black": true,
    "Lavender_Charcoal Grey": true,
    "Lavender_Dark Mocha": true,
    "Lavender_Dark Orange": true,
    "Lavender_Dark Purple": true,
    "Lavender_Dark Saddle Brown": true,
    "Lavender_Deep Teal": true,
    "Lavender_Espresso Brown": true,
    "Lavender_Golden Yellow": true,
    "Lavender_Light Grey": true,
    "Lavender_Lime Green": true,
    "Lavender_Mid Grey": true,
    "Lavender_Midnight Blue": true,
    "Lavender_Olive Green": true,
    "Lavender_Orange": true,
    "Lavender_Peanut Butter": true,
    "Lavender_Pink": true,
    "Lavender_Red": true,
    "Lavender_Royal Blue": true,
    "Lavender_Saddle Brown": true,
    "Lavender_Sage Grey": true,
    "Lavender_Sand": true,
    "Lavender_Sky Blue": true,
    "Lavender_Slate Blue": true,
    "Lavender_Slate Grey": true,
    "Lavender_Soft Plum": true,
    "Lavender_Steel Blue": true,
    "Lavender_Warm Khaki": true,
    "Lavender_White": true,
    "Lavender_Wine Red": true,
    "Light Grey_Light Grey": true,
    "Light Grey_Aqua Blue": true,
    "Light Grey_Beige": true,
    "Light Grey_Black": true,
    "Light Grey_Charcoal Grey": true,
    "Light Grey_Dark Mocha": true,
    "Light Grey_Dark Orange": true,
    "Light Grey_Dark Purple": true,
    "Light Grey_Dark Saddle Brown": true,
    "Light Grey_Deep Teal": true,
    "Light Grey_Espresso Brown": true,
    "Light Grey_Golden Yellow": true,
    "Light Grey_Lavender": true,
    "Light Grey_Lime Green": true,
    "Light Grey_Mid Grey": true,
    "Light Grey_Midnight Blue": true,
    "Light Grey_Olive Green": true,
    "Light Grey_Orange": true,
    "Light Grey_Peanut Butter": true,
    "Light Grey_Pink": true,
    "Light Grey_Red": true,
    "Light Grey_Royal Blue": true,
    "Light Grey_Saddle Brown": true,
    "Light Grey_Sage Grey": true,
    "Light Grey_Sand": true,
    "Light Grey_Sky Blue": true,
    "Light Grey_Slate Blue": true,
    "Light Grey_Slate Grey": true,
    "Light Grey_Soft Plum": true,
    "Light Grey_Steel Blue": true,
    "Light Grey_Warm Khaki": true,
    "Light Grey_White": true,
    "Light Grey_Wine Red": true,
    "Lime Green_Lime Green": true,
    "Lime Green_Aqua Blue": true,
    "Lime Green_Beige": true,
    "Lime Green_Black": true,
    "Lime Green_Charcoal Grey": true,
    "Lime Green_Dark Mocha": true,
    "Lime Green_Dark Orange": true,
    "Lime Green_Dark Purple": true,
    "Lime Green_Dark Saddle Brown": true,
    "Lime Green_Deep Teal": true,
    "Lime Green_Espresso Brown": true,
    "Lime Green_Golden Yellow": true,
    "Lime Green_Lavender": true,
    "Lime Green_Light Grey": true,
    "Lime Green_Mid Grey": true,
    "Lime Green_Midnight Blue": true,
    "Lime Green_Olive Green": true,
    "Lime Green_Orange": true,
    "Lime Green_Peanut Butter": true,
    "Lime Green_Pink": true,
    "Lime Green_Red": true,
    "Lime Green_Royal Blue": true,
    "Lime Green_Saddle Brown": true,
    "Lime Green_Sage Grey": true,
    "Lime Green_Sand": true,
    "Lime Green_Sky Blue": true,
    "Lime Green_Slate Blue": true,
    "Lime Green_Slate Grey": true,
    "Lime Green_Soft Plum": true,
    "Lime Green_Steel Blue": true,
    "Lime Green_Warm Khaki": true,
    "Lime Green_White": true,
    "Lime Green_Wine Red": true,
    "Mid Grey_Mid Grey": true,
    "Mid Grey_Aqua Blue": true,
    "Mid Grey_Beige": true,
    "Mid Grey_Black": true,
    "Mid Grey_Charcoal Grey": true,
    "Mid Grey_Dark Mocha": true,
    "Mid Grey_Dark Orange": true,
    "Mid Grey_Dark Purple": true,
    "Mid Grey_Dark Saddle Brown": true,
    "Mid Grey_Deep Teal": true,
    "Mid Grey_Espresso Brown": true,
    "Mid Grey_Golden Yellow": true,
    "Mid Grey_Lavender": true,
    "Mid Grey_Light Grey": true,
    "Mid Grey_Lime Green": true,
    "Mid Grey_Midnight Blue": true,
    "Mid Grey_Olive Green": true,
    "Mid Grey_Orange": true,
    "Mid Grey_Peanut Butter": true,
    "Mid Grey_Pink": true,
    "Mid Grey_Red": true,
    "Mid Grey_Royal Blue": true,
    "Mid Grey_Saddle Brown": true,
    "Mid Grey_Sage Grey": true,
    "Mid Grey_Sand": true,
    "Mid Grey_Sky Blue": true,
    "Mid Grey_Slate Blue": true,
    "Mid Grey_Slate Grey": true,
    "Mid Grey_Soft Plum": true,
    "Mid Grey_Steel Blue": true,
    "Mid Grey_Warm Khaki": true,
    "Mid Grey_White": true,
    "Mid Grey_Wine Red": true,
    "Midnight Blue_Midnight Blue": true,
    "Midnight Blue_Aqua Blue": true,
    "Midnight Blue_Beige": true,
    "Midnight Blue_Black": true,
    "Midnight Blue_Charcoal Grey": true,
    "Midnight Blue_Dark Mocha": true,
    "Midnight Blue_Dark Orange": true,
    "Midnight Blue_Dark Purple": true,
    "Midnight Blue_Dark Saddle Brown": true,
    "Midnight Blue_Deep Teal": true,
    "Midnight Blue_Espresso Brown": true,
    "Midnight Blue_Golden Yellow": true,
    "Midnight Blue_Lavender": true,
    "Midnight Blue_Light Grey": true,
    "Midnight Blue_Lime Green": true,
    "Midnight Blue_Mid Grey": true,
    "Midnight Blue_Olive Green": true,
    "Midnight Blue_Orange": true,
    "Midnight Blue_Peanut Butter": true,
    "Midnight Blue_Pink": true,
    "Midnight Blue_Red": true,
    "Midnight Blue_Royal Blue": true,
    "Midnight Blue_Saddle Brown": true,
    "Midnight Blue_Sage Grey": true,
    "Midnight Blue_Sand": true,
    "Midnight Blue_Sky Blue": true,
    "Midnight Blue_Slate Blue": true,
    "Midnight Blue_Slate Grey": true,
    "Midnight Blue_Soft Plum": true,
    "Midnight Blue_Steel Blue": true,
    "Midnight Blue_Warm Khaki": true,
    "Midnight Blue_White": true,
    "Midnight Blue_Wine Red": true,
    "Olive Green_Olive Green": true,
    "Olive Green_Aqua Blue": true,
    "Olive Green_Beige": true,
    "Olive Green_Black": true,
    "Olive Green_Charcoal Grey": true,
    "Olive Green_Dark Mocha": true,
    "Olive Green_Dark Orange": true,
    "Olive Green_Dark Purple": true,
    "Olive Green_Dark Saddle Brown": true,
    "Olive Green_Deep Teal": true,
    "Olive Green_Espresso Brown": true,
    "Olive Green_Golden Yellow": true,
    "Olive Green_Lavender": true,
    "Olive Green_Light Grey": true,
    "Olive Green_Lime Green": true,
    "Olive Green_Mid Grey": true,
    "Olive Green_Midnight Blue": true,
    "Olive Green_Orange": true,
    "Olive Green_Peanut Butter": true,
    "Olive Green_Pink": true,
    "Olive Green_Red": true,
    "Olive Green_Royal Blue": true,
    "Olive Green_Saddle Brown": true,
    "Olive Green_Sage Grey": true,
    "Olive Green_Sand": true,
    "Olive Green_Sky Blue": true,
    "Olive Green_Slate Blue": true,
    "Olive Green_Slate Grey": true,
    "Olive Green_Soft Plum": true,
    "Olive Green_Steel Blue": true,
    "Olive Green_Warm Khaki": true,
    "Olive Green_White": true,
    "Olive Green_Wine Red": true,
    "Orange_Orange": true,
    "Orange_Aqua Blue": true,
    "Orange_Beige": true,
    "Orange_Black": true,
    "Orange_Charcoal Grey": true,
    "Orange_Dark Mocha": true,
    "Orange_Dark Orange": true,
    "Orange_Dark Purple": true,
    "Orange_Dark Saddle Brown": true,
    "Orange_Deep Teal": true,
    "Orange_Espresso Brown": true,
    "Orange_Golden Yellow": true,
    "Orange_Lavender": true,
    "Orange_Light Grey": true,
    "Orange_Lime Green": true,
    "Orange_Mid Grey": true,
    "Orange_Midnight Blue": true,
    "Orange_Olive Green": true,
    "Orange_Peanut Butter": true,
    "Orange_Pink": true,
    "Orange_Red": true,
    "Orange_Royal Blue": true,
    "Orange_Saddle Brown": true,
    "Orange_Sage Grey": true,
    "Orange_Sand": true,
    "Orange_Sky Blue": true,
    "Orange_Slate Blue": true,
    "Orange_Slate Grey": true,
    "Orange_Soft Plum": true,
    "Orange_Steel Blue": true,
    "Orange_Warm Khaki": true,
    "Orange_White": true,
    "Orange_Wine Red": true,
    "Peanut Butter_Peanut Butter": true,
    "Peanut Butter_Aqua Blue": true,
    "Peanut Butter_Beige": true,
    "Peanut Butter_Black": true,
    "Peanut Butter_Charcoal Grey": true,
    "Peanut Butter_Dark Mocha": true,
    "Peanut Butter_Dark Orange": true,
    "Peanut Butter_Dark Purple": true,
    "Peanut Butter_Dark Saddle Brown": true,
    "Peanut Butter_Deep Teal": true,
    "Peanut Butter_Espresso Brown": true,
    "Peanut Butter_Golden Yellow": true,
    "Peanut Butter_Lavender": true,
    "Peanut Butter_Light Grey": true,
    "Peanut Butter_Lime Green": true,
    "Peanut Butter_Mid Grey": true,
    "Peanut Butter_Midnight Blue": true,
    "Peanut Butter_Olive Green": true,
    "Peanut Butter_Orange": true,
    "Peanut Butter_Pink": true,
    "Peanut Butter_Red": true,
    "Peanut Butter_Royal Blue": true,
    "Peanut Butter_Saddle Brown": true,
    "Peanut Butter_Sage Grey": true,
    "Peanut Butter_Sand": true,
    "Peanut Butter_Sky Blue": true,
    "Peanut Butter_Slate Blue": true,
    "Peanut Butter_Slate Grey": true,
    "Peanut Butter_Soft Plum": true,
    "Peanut Butter_Steel Blue": true,
    "Peanut Butter_Warm Khaki": true,
    "Peanut Butter_White": true,
    "Peanut Butter_Wine Red": true,
    "Pink_Pink": true,
    "Pink_Aqua Blue": true,
    "Pink_Beige": true,
    "Pink_Black": true,
    "Pink_Charcoal Grey": true,
    "Pink_Dark Mocha": true,
    "Pink_Dark Orange": true,
    "Pink_Dark Purple": true,
    "Pink_Dark Saddle Brown": true,
    "Pink_Deep Teal": true,
    "Pink_Espresso Brown": true,
    "Pink_Golden Yellow": true,
    "Pink_Lavender": true,
    "Pink_Light Grey": true,
    "Pink_Lime Green": true,
    "Pink_Mid Grey": true,
    "Pink_Midnight Blue": true,
    "Pink_Olive Green": true,
    "Pink_Orange": true,
    "Pink_Peanut Butter": true,
    "Pink_Red": true,
    "Pink_Royal Blue": true,
    "Pink_Saddle Brown": true,
    "Pink_Sage Grey": true,
    "Pink_Sand": true,
    "Pink_Sky Blue": true,
    "Pink_Slate Blue": true,
    "Pink_Slate Grey": true,
    "Pink_Soft Plum": true,
    "Pink_Steel Blue": true,
    "Pink_Warm Khaki": true,
    "Pink_White": true,
    "Pink_Wine Red": true,
    "Red_Red": true,
    "Red_Aqua Blue": true,
    "Red_Beige": true,
    "Red_Black": true,
    "Red_Charcoal Grey": true,
    "Red_Dark Mocha": true,
    "Red_Dark Orange": true,
    "Red_Dark Purple": true,
    "Red_Dark Saddle Brown": true,
    "Red_Deep Teal": true,
    "Red_Espresso Brown": true,
    "Red_Golden Yellow": true,
    "Red_Lavender": true,
    "Red_Light Grey": true,
    "Red_Lime Green": true,
    "Red_Mid Grey": true,
    "Red_Midnight Blue": true,
    "Red_Olive Green": true,
    "Red_Orange": true,
    "Red_Peanut Butter": true,
    "Red_Pink": true,
    "Red_Royal Blue": true,
    "Red_Saddle Brown": true,
    "Red_Sage Grey": true,
    "Red_Sand": true,
    "Red_Sky Blue": true,
    "Red_Slate Blue": true,
    "Red_Slate Grey": true,
    "Red_Soft Plum": true,
    "Red_Steel Blue": true,
    "Red_Warm Khaki": true,
    "Red_White": true,
    "Red_Wine Red": true,
    "Royal Blue_Royal Blue": true,
    "Royal Blue_Aqua Blue": true,
    "Royal Blue_Beige": true,
    "Royal Blue_Black": true,
    "Royal Blue_Charcoal Grey": true,
    "Royal Blue_Dark Mocha": true,
    "Royal Blue_Dark Orange": true,
    "Royal Blue_Dark Purple": true,
    "Royal Blue_Dark Saddle Brown": true,
    "Royal Blue_Deep Teal": true,
    "Royal Blue_Espresso Brown": true,
    "Royal Blue_Golden Yellow": true,
    "Royal Blue_Lavender": true,
    "Royal Blue_Light Grey": true,
    "Royal Blue_Lime Green": true,
    "Royal Blue_Mid Grey": true,
    "Royal Blue_Midnight Blue": true,
    "Royal Blue_Olive Green": true,
    "Royal Blue_Orange": true,
    "Royal Blue_Peanut Butter": true,
    "Royal Blue_Pink": true,
    "Royal Blue_Red": true,
    "Royal Blue_Saddle Brown": true,
    "Royal Blue_Sage Grey": true,
    "Royal Blue_Sand": true,
    "Royal Blue_Sky Blue": true,
    "Royal Blue_Slate Blue": true,
    "Royal Blue_Slate Grey": true,
    "Royal Blue_Soft Plum": true,
    "Royal Blue_Steel Blue": true,
    "Royal Blue_Warm Khaki": true,
    "Royal Blue_White": true,
    "Royal Blue_Wine Red": true,
    "Saddle Brown_Saddle Brown": true,
    "Saddle Brown_Aqua Blue": true,
    "Saddle Brown_Beige": true,
    "Saddle Brown_Black": true,
    "Saddle Brown_Charcoal Grey": true,
    "Saddle Brown_Dark Mocha": true,
    "Saddle Brown_Dark Orange": true,
    "Saddle Brown_Dark Purple": true,
    "Saddle Brown_Dark Saddle Brown": true,
    "Saddle Brown_Deep Teal": true,
    "Saddle Brown_Espresso Brown": true,
    "Saddle Brown_Golden Yellow": true,
    "Saddle Brown_Lavender": true,
    "Saddle Brown_Light Grey": true,
    "Saddle Brown_Lime Green": true,
    "Saddle Brown_Mid Grey": true,
    "Saddle Brown_Midnight Blue": true,
    "Saddle Brown_Olive Green": true,
    "Saddle Brown_Orange": true,
    "Saddle Brown_Peanut Butter": true,
    "Saddle Brown_Pink": true,
    "Saddle Brown_Red": true,
    "Saddle Brown_Royal Blue": true,
    "Saddle Brown_Sage Grey": true,
    "Saddle Brown_Sand": true,
    "Saddle Brown_Sky Blue": true,
    "Saddle Brown_Slate Blue": true,
    "Saddle Brown_Slate Grey": true,
    "Saddle Brown_Soft Plum": true,
    "Saddle Brown_Steel Blue": true,
    "Saddle Brown_Warm Khaki": true,
    "Saddle Brown_White": true,
    "Saddle Brown_Wine Red": true,
    "Sage Grey_Sage Grey": true,
    "Sage Grey_Aqua Blue": true,
    "Sage Grey_Beige": true,
    "Sage Grey_Black": true,
    "Sage Grey_Charcoal Grey": true,
    "Sage Grey_Dark Mocha": true,
    "Sage Grey_Dark Orange": true,
    "Sage Grey_Dark Purple": true,
    "Sage Grey_Dark Saddle Brown": true,
    "Sage Grey_Deep Teal": true,
    "Sage Grey_Espresso Brown": true,
    "Sage Grey_Golden Yellow": true,
    "Sage Grey_Lavender": true,
    "Sage Grey_Light Grey": true,
    "Sage Grey_Lime Green": true,
    "Sage Grey_Mid Grey": true,
    "Sage Grey_Midnight Blue": true,
    "Sage Grey_Olive Green": true,
    "Sage Grey_Orange": true,
    "Sage Grey_Peanut Butter": true,
    "Sage Grey_Pink": true,
    "Sage Grey_Red": true,
    "Sage Grey_Royal Blue": true,
    "Sage Grey_Saddle Brown": true,
    "Sage Grey_Sand": true,
    "Sage Grey_Sky Blue": true,
    "Sage Grey_Slate Blue": true,
    "Sage Grey_Slate Grey": true,
    "Sage Grey_Soft Plum": true,
    "Sage Grey_Steel Blue": true,
    "Sage Grey_Warm Khaki": true,
    "Sage Grey_White": true,
    "Sage Grey_Wine Red": true,
    "Sand_Sand": true,
    "Sand_Aqua Blue": true,
    "Sand_Beige": true,
    "Sand_Black": true,
    "Sand_Charcoal Grey": true,
    "Sand_Dark Mocha": true,
    "Sand_Dark Orange": true,
    "Sand_Dark Purple": true,
    "Sand_Dark Saddle Brown": true,
    "Sand_Deep Teal": true,
    "Sand_Espresso Brown": true,
    "Sand_Golden Yellow": true,
    "Sand_Lavender": true,
    "Sand_Light Grey": true,
    "Sand_Lime Green": true,
    "Sand_Mid Grey": true,
    "Sand_Midnight Blue": true,
    "Sand_Olive Green": true,
    "Sand_Orange": true,
    "Sand_Peanut Butter": true,
    "Sand_Pink": true,
    "Sand_Red": true,
    "Sand_Royal Blue": true,
    "Sand_Saddle Brown": true,
    "Sand_Sage Grey": true,
    "Sand_Sky Blue": true,
    "Sand_Slate Blue": true,
    "Sand_Slate Grey": true,
    "Sand_Soft Plum": true,
    "Sand_Steel Blue": true,
    "Sand_Warm Khaki": true,
    "Sand_White": true,
    "Sand_Wine Red": true,
    "Sky Blue_Sky Blue": true,
    "Sky Blue_Aqua Blue": true,
    "Sky Blue_Beige": true,
    "Sky Blue_Black": true,
    "Sky Blue_Charcoal Grey": true,
    "Sky Blue_Dark Mocha": true,
    "Sky Blue_Dark Orange": true,
    "Sky Blue_Dark Purple": true,
    "Sky Blue_Dark Saddle Brown": true,
    "Sky Blue_Deep Teal": true,
    "Sky Blue_Espresso Brown": true,
    "Sky Blue_Golden Yellow": true,
    "Sky Blue_Lavender": true,
    "Sky Blue_Light Grey": true,
    "Sky Blue_Lime Green": true,
    "Sky Blue_Mid Grey": true,
    "Sky Blue_Midnight Blue": true,
    "Sky Blue_Olive Green": true,
    "Sky Blue_Orange": true,
    "Sky Blue_Peanut Butter": true,
    "Sky Blue_Pink": true,
    "Sky Blue_Red": true,
    "Sky Blue_Royal Blue": true,
    "Sky Blue_Saddle Brown": true,
    "Sky Blue_Sage Grey": true,
    "Sky Blue_Sand": true,
    "Sky Blue_Slate Blue": true,
    "Sky Blue_Slate Grey": true,
    "Sky Blue_Soft Plum": true,
    "Sky Blue_Steel Blue": true,
    "Sky Blue_Warm Khaki": true,
    "Sky Blue_White": true,
    "Sky Blue_Wine Red": true,
    "Slate Blue_Slate Blue": true,
    "Slate Blue_Aqua Blue": true,
    "Slate Blue_Beige": true,
    "Slate Blue_Black": true,
    "Slate Blue_Charcoal Grey": true,
    "Slate Blue_Dark Mocha": true,
    "Slate Blue_Dark Orange": true,
    "Slate Blue_Dark Purple": true,
    "Slate Blue_Dark Saddle Brown": true,
    "Slate Blue_Deep Teal": true,
    "Slate Blue_Espresso Brown": true,
    "Slate Blue_Golden Yellow": true,
    "Slate Blue_Lavender": true,
    "Slate Blue_Light Grey": true,
    "Slate Blue_Lime Green": true,
    "Slate Blue_Mid Grey": true,
    "Slate Blue_Midnight Blue": true,
    "Slate Blue_Olive Green": true,
    "Slate Blue_Orange": true,
    "Slate Blue_Peanut Butter": true,
    "Slate Blue_Pink": true,
    "Slate Blue_Red": true,
    "Slate Blue_Royal Blue": true,
    "Slate Blue_Saddle Brown": true,
    "Slate Blue_Sage Grey": true,
    "Slate Blue_Sand": true,
    "Slate Blue_Sky Blue": true,
    "Slate Blue_Slate Grey": true,
    "Slate Blue_Soft Plum": true,
    "Slate Blue_Steel Blue": true,
    "Slate Blue_Warm Khaki": true,
    "Slate Blue_White": true,
    "Slate Blue_Wine Red": true,
    "Slate Grey_Slate Grey": true,
    "Slate Grey_Aqua Blue": true,
    "Slate Grey_Beige": true,
    "Slate Grey_Black": true,
    "Slate Grey_Charcoal Grey": true,
    "Slate Grey_Dark Mocha": true,
    "Slate Grey_Dark Orange": true,
    "Slate Grey_Dark Purple": true,
    "Slate Grey_Dark Saddle Brown": true,
    "Slate Grey_Deep Teal": true,
    "Slate Grey_Espresso Brown": true,
    "Slate Grey_Golden Yellow": true,
    "Slate Grey_Lavender": true,
    "Slate Grey_Light Grey": true,
    "Slate Grey_Lime Green": true,
    "Slate Grey_Mid Grey": true,
    "Slate Grey_Midnight Blue": true,
    "Slate Grey_Olive Green": true,
    "Slate Grey_Orange": true,
    "Slate Grey_Peanut Butter": true,
    "Slate Grey_Pink": true,
    "Slate Grey_Red": true,
    "Slate Grey_Royal Blue": true,
    "Slate Grey_Saddle Brown": true,
    "Slate Grey_Sage Grey": true,
    "Slate Grey_Sand": true,
    "Slate Grey_Sky Blue": true,
    "Slate Grey_Slate Blue": true,
    "Slate Grey_Soft Plum": true,
    "Slate Grey_Steel Blue": true,
    "Slate Grey_Warm Khaki": true,
    "Slate Grey_White": true,
    "Slate Grey_Wine Red": true,
    "Soft Plum_Soft Plum": true,
    "Soft Plum_Aqua Blue": true,
    "Soft Plum_Beige": true,
    "Soft Plum_Black": true,
    "Soft Plum_Charcoal Grey": true,
    "Soft Plum_Dark Mocha": true,
    "Soft Plum_Dark Orange": true,
    "Soft Plum_Dark Purple": true,
    "Soft Plum_Dark Saddle Brown": true,
    "Soft Plum_Deep Teal": true,
    "Soft Plum_Espresso Brown": true,
    "Soft Plum_Golden Yellow": true,
    "Soft Plum_Lavender": true,
    "Soft Plum_Light Grey": true,
    "Soft Plum_Lime Green": true,
    "Soft Plum_Mid Grey": true,
    "Soft Plum_Midnight Blue": true,
    "Soft Plum_Olive Green": true,
    "Soft Plum_Orange": true,
    "Soft Plum_Peanut Butter": true,
    "Soft Plum_Pink": true,
    "Soft Plum_Red": true,
    "Soft Plum_Royal Blue": true,
    "Soft Plum_Saddle Brown": true,
    "Soft Plum_Sage Grey": true,
    "Soft Plum_Sand": true,
    "Soft Plum_Sky Blue": true,
    "Soft Plum_Slate Blue": true,
    "Soft Plum_Slate Grey": true,
    "Soft Plum_Steel Blue": true,
    "Soft Plum_Warm Khaki": true,
    "Soft Plum_White": true,
    "Soft Plum_Wine Red": true,
    "Steel Blue_Steel Blue": true,
    "Steel Blue_Aqua Blue": true,
    "Steel Blue_Beige": true,
    "Steel Blue_Black": true,
    "Steel Blue_Charcoal Grey": true,
    "Steel Blue_Dark Mocha": true,
    "Steel Blue_Dark Orange": true,
    "Steel Blue_Dark Purple": true,
    "Steel Blue_Dark Saddle Brown": true,
    "Steel Blue_Deep Teal": true,
    "Steel Blue_Espresso Brown": true,
    "Steel Blue_Golden Yellow": true,
    "Steel Blue_Lavender": true,
    "Steel Blue_Light Grey": true,
    "Steel Blue_Lime Green": true,
    "Steel Blue_Mid Grey": true,
    "Steel Blue_Midnight Blue": true,
    "Steel Blue_Olive Green": true,
    "Steel Blue_Orange": true,
    "Steel Blue_Peanut Butter": true,
    "Steel Blue_Pink": true,
    "Steel Blue_Red": true,
    "Steel Blue_Royal Blue": true,
    "Steel Blue_Saddle Brown": true,
    "Steel Blue_Sage Grey": true,
    "Steel Blue_Sand": true,
    "Steel Blue_Sky Blue": true,
    "Steel Blue_Slate Blue": true,
    "Steel Blue_Slate Grey": true,
    "Steel Blue_Soft Plum": true,
    "Steel Blue_Warm Khaki": true,
    "Steel Blue_White": true,
    "Steel Blue_Wine Red": true,
    "Warm Khaki_Warm Khaki": true,
    "Warm Khaki_Aqua Blue": true,
    "Warm Khaki_Beige": true,
    "Warm Khaki_Black": true,
    "Warm Khaki_Charcoal Grey": true,
    "Warm Khaki_Dark Mocha": true,
    "Warm Khaki_Dark Orange": true,
    "Warm Khaki_Dark Purple": true,
    "Warm Khaki_Dark Saddle Brown": true,
    "Warm Khaki_Deep Teal": true,
    "Warm Khaki_Espresso Brown": true,
    "Warm Khaki_Golden Yellow": true,
    "Warm Khaki_Lavender": true,
    "Warm Khaki_Light Grey": true,
    "Warm Khaki_Lime Green": true,
    "Warm Khaki_Mid Grey": true,
    "Warm Khaki_Midnight Blue": true,
    "Warm Khaki_Olive Green": true,
    "Warm Khaki_Orange": true,
    "Warm Khaki_Peanut Butter": true,
    "Warm Khaki_Pink": true,
    "Warm Khaki_Red": true,
    "Warm Khaki_Royal Blue": true,
    "Warm Khaki_Saddle Brown": true,
    "Warm Khaki_Sage Grey": true,
    "Warm Khaki_Sand": true,
    "Warm Khaki_Sky Blue": true,
    "Warm Khaki_Slate Blue": true,
    "Warm Khaki_Slate Grey": true,
    "Warm Khaki_Soft Plum": true,
    "Warm Khaki_Steel Blue": true,
    "Warm Khaki_White": true,
    "Warm Khaki_Wine Red": true,
    "White_White": true,
    "White_Aqua Blue": true,
    "White_Beige": true,
    "White_Black": true,
    "White_Charcoal Grey": true,
    "White_Dark Mocha": true,
    "White_Dark Orange": true,
    "White_Dark Purple": true,
    "White_Dark Saddle Brown": true,
    "White_Deep Teal": true,
    "White_Espresso Brown": true,
    "White_Golden Yellow": true,
    "White_Lavender": true,
    "White_Light Grey": true,
    "White_Lime Green": true,
    "White_Mid Grey": true,
    "White_Midnight Blue": true,
    "White_Olive Green": true,
    "White_Orange": true,
    "White_Peanut Butter": true,
    "White_Pink": true,
    "White_Red": true,
    "White_Royal Blue": true,
    "White_Saddle Brown": true,
    "White_Sage Grey": true,
    "White_Sand": true,
    "White_Sky Blue": true,
    "White_Slate Blue": true,
    "White_Slate Grey": true,
    "White_Soft Plum": true,
    "White_Steel Blue": true,
    "White_Warm Khaki": true,
    "White_Wine Red": true,
    "Wine Red_Wine Red": true,
    "Wine Red_Aqua Blue": true,
    "Wine Red_Beige": true,
    "Wine Red_Black": true,
    "Wine Red_Charcoal Grey": true,
    "Wine Red_Dark Mocha": true,
    "Wine Red_Dark Orange": true,
    "Wine Red_Dark Purple": true,
    "Wine Red_Dark Saddle Brown": true,
    "Wine Red_Deep Teal": true,
    "Wine Red_Espresso Brown": true,
    "Wine Red_Golden Yellow": true,
    "Wine Red_Lavender": true,
    "Wine Red_Light Grey": true,
    "Wine Red_Lime Green": true,
    "Wine Red_Mid Grey": true,
    "Wine Red_Midnight Blue": true,
    "Wine Red_Olive Green": true,
    "Wine Red_Orange": true,
    "Wine Red_Peanut Butter": true,
    "Wine Red_Pink": true,
    "Wine Red_Red": true,
    "Wine Red_Royal Blue": true,
    "Wine Red_Saddle Brown": true,
    "Wine Red_Sage Grey": true,
    "Wine Red_Sand": true,
    "Wine Red_Sky Blue": true,
    "Wine Red_Slate Blue": true,
    "Wine Red_Slate Grey": true,
    "Wine Red_Soft Plum": true,
    "Wine Red_Steel Blue": true,
    "Wine Red_Warm Khaki": true,
    "Wine Red_White": true
   },
   "count": 1089
  }
 },
 "revisions": {
  "Basic/Black_Sage Grey/full": 2,
  "Basic/Black_Sage Grey/fronts_jump": 2,
  "Basic/Black_Sage Grey/full_jump": 2,
  "Basic/Charcoal Grey_Dark Mocha/full": 2,
  "Basic/Charcoal Grey_Dark Mocha/fronts_jump": 2,
  "Basic/Charcoal Grey_Dark Mocha/full_jump": 2,
  "Basic/Charcoal Grey_Dark Saddle Brown/full": 2,
  "Basic/Charcoal Grey_Dark Saddle Brown/fronts_jump": 2,
  "Basic/Charcoal Grey_Dark Saddle Brown/full_jump": 2,
  "Basic/Charcoal Grey_Slate Blue/full": 2,
  "Basic/Charcoal Grey_Slate Blue/fronts_jump": 2,
  "Basic/Charcoal Grey_Slate Blue/full_jump": 2,
  "Basic/Dark Mocha_Saddle Brown/full": 2,
  "Basic/Dark Mocha_Saddle Brown/fronts_jump": 2,
  "Basic/Dark Mocha_Saddle Brown/full_jump": 2,
  "Basic/Dark Mocha_Slate Blue/full": 2,
  "Basic/Dark Mocha_Slate Blue/fronts_jump": 2,
  "Basic/Dark Mocha_Slate Blue/full_jump": 2,
  "Basic/Dark Mocha_Steel Blue/full": 2,
  "Basic/Dark Mocha_Steel Blue/fronts_jump": 2,
  "Basic/Dark Mocha_Steel Blue/full_jump": 2,
  "Basic/Dark Purple_Sage Grey/full": 2,
  "Basic/Dark Purple_Sage Grey/fronts_jump": 2,
  "Basic/Dark Purple_Sage Grey/full_jump": 2,
  "Basic/Dark Purple_Slate Blue/full": 2,
  "Basic/Dark Purple_Slate Blue/fronts_jump": 2,
  "Basic/Dark Purple_Slate Blue/full_jump": 2,
  "Basic/Dark Purple_Steel Blue/full": 2,
  "Basic/Dark Purple_Steel Blue/fronts_jump": 2,
  "Basic/Dark Purple_Steel Blue/full_jump": 2,
  "Basic/Dark Purple_Wine Red/full": 2,
  "Basic/Dark Purple_Wine Red/fronts_jump": 2,
  "Basic/Dark Purple_Wine Red/full_jump": 2,
  "Basic/Dark Saddle Brown_Mid Grey/full": 3,
  "Basic/Dark Saddle Brown_Mid Grey/fronts_jump": 3,
  "Basic/Dark Saddle Brown_Mid Grey/full_jump": 3,
  "Basic/Dark Saddle Brown_Midnight Blue/full": 2,
  "Basic/Dark Saddle Brown_Midnight Blue/fronts_jump": 2,
  "Basic/Dark Saddle Brown_Midnight Blue/full_jump": 2,
  "Basic/Dark Saddle Brown_Sage Grey/full": 2,
  "Basic/Dark Saddle Brown_Sage Grey/fronts_jump": 2,
  "Basic/Dark Saddle Brown_Sage Grey/full_jump": 2,
  "Basic/Deep Teal_Aqua Blue/full": 2,
  "Basic/Deep Teal_Aqua Blue/fronts_jump": 2,
  "Basic/Deep Teal_Aqua Blue/full_jump": 2,
  "Basic/Deep Teal_Charcoal Grey/full": 2,
  "Basic/Deep Teal_Charcoal Grey/fronts_jump": 2,
  "Basic/Deep Teal_Charcoal Grey/full_jump": 2,
  "Basic/Deep Teal_Sky Blue/full": 2,
  "Basic/Deep Teal_Sky Blue/fronts_jump": 2,
  "Basic/Deep Teal_Sky Blue/full_jump": 2,
  "Basic/Deep Teal_Slate Blue/full": 2,
  "Basic/Deep Teal_Slate Blue/fronts_jump": 2,
  "Basic/Deep Teal_Slate Blue/full_jump": 2,
  "Basic/Espresso Brown_Sage Grey/full": 2,
  "Basic/Espresso Brown_Sage Grey/fronts_jump": 2,
  "Basic/Espresso Brown_Sage Grey/full_jump": 2,
  "Basic/Espresso Brown_Steel Blue/full": 2,
  "Basic/Espresso Brown_Steel Blue/fronts_jump": 2,
  "Basic/Espresso Brown_Steel Blue/full_jump": 2,
  "Basic/Lavender_Black/full": 2,
  "Basic/Lavender_Black/fronts_jump": 2,
  "Basic/Lavender_Black/full_jump": 2,
  "Basic/Mid Grey_Charcoal Grey/full": 3,
  "Basic/Mid Grey_Charcoal Grey/fronts_jump": 3,
  "Basic/Mid Grey_Charcoal Grey/full_jump": 3,
  "Basic/Mid Grey_Dark Mocha/full": 3,
  "Basic/Mid Grey_Dark Mocha/fronts_jump": 3,
  "Basic/Mid Grey_Dark Mocha/full_jump": 3,
  "Basic/Midnight Blue_Aqua Blue/full": 2,
  "Basic/Midnight Blue_Aqua Blue/fronts_jump": 2,
  "Basic/Midnight Blue_Aqua Blue/full_jump": 2,
  "Basic/Midnight Blue_Espresso Brown/full": 2,
  "Basic/Midnight Blue_Espresso Brown/fronts_jump": 2,
  "Basic/Midnight Blue_Espresso Brown/full_jump": 2,
  "Basic/Midnight Blue_Royal Blue/full": 2,
  "Basic/Midnight Blue_Royal Blue/fronts_jump": 2,
  "Basic/Midnight Blue_Royal Blue/full_jump": 2,
  "Basic/Midnight Blue_Slate Blue/full": 2,
  "Basic/Midnight Blue_Slate Blue/fronts_jump": 2,
  "Basic/Midnight Blue_Slate Blue/full_jump": 2,
  "Basic/Olive Green_Charcoal Grey/full": 2,
  "Basic/Olive Green_Charcoal Grey/fronts_jump": 2,
  "Basic/Olive Green_Charcoal Grey/full_jump": 2,
  "Basic/Peanut Butter_Dark Mocha/full": 2,
  "Basic/Peanut Butter_Dark Mocha/fronts_jump": 2,
  "Basic/Peanut Butter_Dark Mocha/full_jump": 2,
  "Basic/Peanut Butter_Dark Purple/full": 2,
  "Basic/Peanut Butter_Dark Purple/fronts_jump": 2,
  "Basic/Peanut Butter_Dark Purple/full_jump": 2,
  "Basic/Pink_Dark Purple/full": 2,
  "Basic/Pink_Dark Purple/fronts_jump": 2,
  "Basic/Pink_Dark Purple/full_jump": 2,
  "Basic/Red_Dark Saddle Brown/full": 2,
  "Basic/Red_Dark Saddle Brown/fronts_jump": 2,
  "Basic/Red_Dark Saddle Brown/full_jump": 2,
  "Basic/Red_Espresso Brown/full": 2,
  "Basic/Red_Espresso Brown/fronts_jump": 2,
  "Basic/Red_Espresso Brown/full_jump": 2,
  "Basic/Red_Midnight Blue/full": 2,
  "Basic/Red_Midnight Blue/fronts_jump": 2,
  "Basic/Red_Midnight Blue/full_jump": 2,
  "Basic/Red_Orange/full": 2,
  "Basic/Red_Orange/fronts_jump": 2,
  "Basic/Red_Orange/full_jump": 2,
  "Basic/Red_Saddle Brown/full": 2,
  "Basic/Red_Saddle Brown/fronts_jump": 2,
  "Basic/Red_Saddle Brown/full_jump": 2,
  "Basic/Red_Wine Red/full": 2,
  "Basic/Red_Wine Red/fronts_jump": 2,
  "Basic/Red_Wine Red/full_jump": 2,
  "Basic/Saddle Brown_Charcoal Grey/full": 2,
  "Basic/Saddle Brown_Charcoal Grey/fronts_jump": 2,
  "Basic/Saddle Brown_Charcoal Grey/full_jump": 2,
  "Basic/Saddle Brown_Lavender/full": 2,
  "Basic/Saddle Brown_Lavender/fronts_jump": 2,
  "Basic/Saddle Brown_Lavender/full_jump": 2,
  "Basic/Saddle Brown_Peanut Butter/full": 2,
  "Basic/Saddle Brown_Peanut Butter/fronts_jump": 2,
  "Basic/Saddle Brown_Peanut Butter/full_jump": 2,
  "Basic/Saddle Brown_Wine Red/full": 2,
  "Basic/Saddle Brown_Wine Red/fronts_jump": 2,
  "Basic/Saddle Brown_Wine Red/full_jump": 2,
  "Basic/Sage Grey_Charcoal Grey/full": 2,
  "Basic/Sage Grey_Charcoal Grey/fronts_jump": 2,
  "Basic/Sage Grey_Charcoal Grey/full_jump": 2,
  "Basic/Sage Grey_Deep Teal/full": 2,
  "Basic/Sage Grey_Deep Teal/fronts_jump": 2,
  "Basic/Sage Grey_Deep Teal/full_jump": 2,
  "Basic/Sand_Dark Mocha/full": 2,
  "Basic/Sand_Dark Mocha/fronts_jump": 2,
  "Basic/Sand_Dark Mocha/full_jump": 2,
  "Basic/Slate Grey_Dark Mocha/full": 2,
  "Basic/Slate Grey_Dark Mocha/fronts_jump": 2,
  "Basic/Slate Grey_Dark Mocha/full_jump": 2,
  "Basic/Slate Grey_Mid Grey/full": 3,
  "Basic/Slate Grey_Mid Grey/fronts_jump": 3,
  "Basic/Slate Grey_Mid Grey/full_jump": 3,
  "Basic/Slate Grey_Steel Blue/full": 2,
  "Basic/Slate Grey_Steel Blue/fronts_jump": 2,
  "Basic/Slate Grey_Steel Blue/full_jump": 2,
  "Basic/Soft Plum/full": 2,
  "Basic/Soft Plum/fronts_jump": 2,
  "Basic/Soft Plum/full_jump": 2,
  "Basic/Soft Plum_Slate Blue/full": 2,
  "Basic/Soft Plum_Slate Blue/fronts_jump": 2,
  "Basic/Soft Plum_Slate Blue/full_jump": 2,
  "Basic/Warm Khaki/full": 2,
  "Basic/Warm Khaki/fronts_jump": 2,
  "Basic/Warm Khaki/full_jump": 2,
  "Basic/Warm Khaki_Dark Mocha/full": 2,
  "Basic/Warm Khaki_Dark Mocha/fronts_jump": 2,
  "Basic/Warm Khaki_Dark Mocha/full_jump": 2,
  "Basic/Wine Red_Pink/full": 2,
  "Basic/Wine Red_Pink/fronts_jump": 2,
  "Basic/Wine Red_Pink/full_jump": 2,
  "Diamond/Aqua Blue_Mid Grey/full": 2,
  "Diamond/Aqua Blue_Mid Grey/fronts": 2,
  "Diamond/Aqua Blue_Mid Grey/backs": 2,
  "Diamond/Aqua Blue_Mid Grey/fronts_jump": 2,
  "Diamond/Aqua Blue_Mid Grey/full_jump": 2,
  "Diamond/Beige_Mid Grey/full": 2,
  "Diamond/Beige_Mid Grey/fronts": 2,
  "Diamond/Beige_Mid Grey/backs": 2,
  "Diamond/Beige_Mid Grey/fronts_jump": 2,
  "Diamond/Beige_Mid Grey/full_jump": 2,
  "Diamond/Black_Mid Grey/full": 2,
  "Diamond/Black_Mid Grey/fronts": 2,
  "Diamond/Black_Mid Grey/backs": 2,
  "Diamond/Black_Mid Grey/fronts_jump": 2,
  "Diamond/Black_Mid Grey/full_jump": 2,
  "Diamond/Charcoal Grey_Mid Grey/full": 2,
  "Diamond/Charcoal Grey_Mid Grey/fronts": 2,
  "Diamond/Charcoal Grey_Mid Grey/backs": 2,
  "Diamond/Charcoal Grey_Mid Grey/fronts_jump": 2,
  "Diamond/Charcoal Grey_Mid Grey/full_jump": 2,
  "Diamond/Dark Mocha_Mid Grey/full": 2,
  "Diamond/Dark Mocha_Mid Grey/fronts": 2,
  "Diamond/Dark Mocha_Mid Grey/backs": 2,
  "Diamond/Dark Mocha_Mid Grey/fronts_jump": 2,
  "Diamond/Dark Mocha_Mid Grey/full_jump": 2,
  "Diamond/Dark Orange_Mid Grey/full": 2,
  "Diamond/Dark Orange_Mid Grey/fronts": 2,
  "Diamond/Dark Orange_Mid Grey/backs": 2,
  "Diamond/Dark Orange_Mid Grey/fronts_jump": 2,
  "Diamond/Dark Orange_Mid Grey/full_jump": 2,
  "Diamond/Dark Purple_Mid Grey/full": 2,
  "Diamond/Dark Purple_Mid Grey/fronts": 2,
  "Diamond/Dark Purple_Mid Grey/backs": 2,
  "Diamond/Dark Purple_Mid Grey/fronts_jump": 2,
  "Diamond/Dark Purple_Mid Grey/full_jump": 2,
  "Diamond/Dark Saddle Brown_Mid Grey/full": 2,
  "Diamond/Dark Saddle Brown_Mid Grey/fronts": 2,
  "Diamond/Dark Saddle Brown_Mid Grey/backs": 2,
  "Diamond/Dark Saddle Brown_Mid Grey/fronts_jump": 2,
  "Diamond/Dark Saddle Brown_Mid Grey/full_jump": 2,
  "Diamond/Deep Teal_Mid Grey/full": 2,
  "Diamond/Deep Teal_Mid Grey/fronts": 2,
  "Diamond/Deep Teal_Mid Grey/backs": 2,
  "Diamond/Deep Teal_Mid Grey/fronts_jump": 2,
  "Diamond/Deep Teal_Mid Grey/full_jump": 2,
  "Diamond/Espresso Brown_Mid Grey/full": 2,
  "Diamond/Espresso Brown_Mid Grey/fronts": 2,
  "Diamond/Espresso Brown_Mid Grey/backs": 2,
  "Diamond/Espresso Brown_Mid Grey/fronts_jump": 2,
  "Diamond/Espresso Brown_Mid Grey/full_jump": 2,
  "Diamond/Golden Yellow_Mid Grey/full": 2,
  "Diamond/Golden Yellow_Mid Grey/fronts": 2,
  "Diamond/Golden Yellow_Mid Grey/backs": 2,
  "Diamond/Golden Yellow_Mid Grey/fronts_jump": 2,
  "Diamond/Golden Yellow_Mid Grey/full_jump": 2,
  "Diamond/Lavender_Mid Grey/full": 2,
  "Diamond/Lavender_Mid Grey/fronts": 2,
  "Diamond/Lavender_Mid Grey/backs": 2,
  "Diamond/Lavender_Mid Grey/fronts_jump": 2,
  "Diamond/Lavender_Mid Grey/full_jump": 2,
  "Diamond/Light Grey_Mid Grey/full": 2,
  "Diamond/Light Grey_Mid Grey/fronts": 2,
  "Diamond/Light Grey_Mid Grey/backs": 2,
  "Diamond/Light Grey_Mid Grey/fronts_jump": 2,
  "Diamond/Light Grey_Mid Grey/full_jump": 2,
  "Diamond/Lime Green_Mid Grey/full": 2,
  "Diamond/Lime Green_Mid Grey/fronts": 2,
  "Diamond/Lime Green_Mid Grey/backs": 2,
  "Diamond/Lime Green_Mid Grey/fronts_jump": 2,
  "Diamond/Lime Green_Mid Grey/full_jump": 2,
  "Diamond/Mid Grey_Aqua Blue/full": 2,
  "Diamond/Mid Grey_Aqua Blue/fronts": 2,
  "Diamond/Mid Grey_Aqua Blue/backs": 2,
  "Diamond/Mid Grey_Aqua Blue/fronts_jump": 2,
  "Diamond/Mid Grey_Aqua Blue/full_jump": 2,
  "Diamond/Mid Grey_Beige/full": 2,
  "Diamond/Mid Grey_Beige/fronts": 2,
  "Diamond/Mid Grey_Beige/backs": 2,
  "Diamond/Mid Grey_Beige/fronts_jump": 2,
  "Diamond/Mid Grey_Beige/full_jump": 2,
  "Diamond/Mid Grey_Black/full": 2,
  "Diamond/Mid Grey_Black/fronts": 2,
  "Diamond/Mid Grey_Black/backs": 2,
  "Diamond/Mid Grey_Black/fronts_jump": 2,
  "Diamond/Mid Grey_Black/full_jump": 2,
  "Diamond/Mid Grey_Charcoal Grey/full": 2,
  "Diamond/Mid Grey_Charcoal Grey/fronts": 2,
  "Diamond/Mid Grey_Charcoal Grey/backs": 2,
  "Diamond/Mid Grey_Charcoal Grey/fronts_jump": 2,
  "Diamond/Mid Grey_Charcoal Grey/full_jump": 2,
  "Diamond/Mid Grey_Dark Mocha/full": 2,
  "Diamond/Mid Grey_Dark Mocha/fronts": 2,
  "Diamond/Mid Grey_Dark Mocha/backs": 2,
  "Diamond/Mid Grey_Dark Mocha/fronts_jump": 2,
  "Diamond/Mid Grey_Dark Mocha/full_jump": 2,
  "Diamond/Mid Grey_Dark Orange/full": 2,
  "Diamond/Mid Grey_Dark Orange/fronts": 2,
  "Diamond/Mid Grey_Dark Orange/backs": 2,
  "Diamond/Mid Grey_Dark Orange/fronts_jump": 2,
  "Diamond/Mid Grey_Dark Orange/full_jump": 2,
  "Diamond/Mid Grey_Dark Purple/full": 2,
  "Diamond/Mid Grey_Dark Purple/fronts": 2,
  "Diamond/Mid Grey_Dark Purple/backs": 2,
  "Diamond/Mid Grey_Dark Purple/fronts_jump": 2,
  "Diamond/Mid Grey_Dark Purple/full_jump": 2,
  "Diamond/Mid Grey_Dark Saddle Brown/full": 2,
  "Diamond/Mid Grey_Dark Saddle Brown/fronts": 2,
  "Diamond/Mid Grey_Dark Saddle Brown/backs": 2,
  "Diamond/Mid Grey_Dark Saddle Brown/fronts_jump": 2,
  "Diamond/Mid Grey_Dark Saddle Brown/full_jump": 2,
  "Diamond/Mid Grey_Deep Teal/full": 2,
  "Diamond/Mid Grey_Deep Teal/fronts": 2,
  "Diamond/Mid Grey_Deep Teal/backs": 2,
  "Diamond/Mid Grey_Deep Teal/fronts_jump": 2,
  "Diamond/Mid Grey_Deep Teal/full_jump": 2,
  "Diamond/Mid Grey_Espresso Brown/full": 2,
  "Diamond/Mid Grey_Espresso Brown/fronts": 2,
  "Diamond/Mid Grey_Espresso Brown/backs": 2,
  "Diamond/Mid Grey_Espresso Brown/fronts_jump": 2,
  "Diamond/Mid Grey_Espresso Brown/full_jump": 2,
  "Diamond/Mid Grey_Golden Yellow/full": 2,
  "Diamond/Mid Grey_Golden Yellow/fronts": 2,
  "Diamond/Mid Grey_Golden Yellow/backs": 2,
  "Diamond/Mid Grey_Golden Yellow/fronts_jump": 2,
  "Diamond/Mid Grey_Golden Yellow/full_jump": 2,
  "Diamond/Mid Grey_Lavender/full": 2,
  "Diamond/Mid Grey_Lavender/fronts": 2,
  "Diamond/Mid Grey_Lavender/backs": 2,
  "Diamond/Mid Grey_Lavender/fronts_jump": 2,
  "Diamond/Mid Grey_Lavender/full_jump": 2,
  "Diamond/Mid Grey_Light Grey/full": 2,
  "Diamond/Mid Grey_Light Grey/fronts": 2,
  "Diamond/Mid Grey_Light Grey/backs": 2,
  "Diamond/Mid Grey_Light Grey/fronts_jump": 2,
  "Diamond/Mid Grey_Light Grey/full_jump": 2,
  "Diamond/Mid Grey_Lime Green/full": 2,
  "Diamond/Mid Grey_Lime Green/fronts": 2,
  "Diamond/Mid Grey_Lime Green/backs": 2,
  "Diamond/Mid Grey_Lime Green/fronts_jump": 2,
  "Diamond/Mid Grey_Lime Green/full_jump": 2,
  "Diamond/Mid Grey/full": 2,
  "Diamond/Mid Grey/fronts": 2,
  "Diamond/Mid Grey/backs": 2,
  "Diamond/Mid Grey/fronts_jump": 2,
  "Diamond/Mid Grey/full_jump": 2,
  "Diamond/Mid Grey_Midnight Blue/full": 2,
  "Diamond/Mid Grey_Midnight Blue/fronts": 2,
  "Diamond/Mid Grey_Midnight Blue/backs": 2,
  "Diamond/Mid Grey_Midnight Blue/fronts_jump": 2,
  "Diamond/Mid Grey_Midnight Blue/full_jump": 2,
  "Diamond/Mid Grey_Olive Green/full": 2,
  "Diamond/Mid Grey_Olive Green/fronts": 2,
  "Diamond/Mid Grey_Olive Green/backs": 2,
  "Diamond/Mid Grey_Olive Green/fronts_jump": 2,
  "Diamond/Mid Grey_Olive Green/full_jump": 2,
  "Diamond/Mid Grey_Orange/full": 2,
  "Diamond/Mid Grey_Orange/fronts": 2,
  "Diamond/Mid Grey_Orange/backs": 2,
  "Diamond/Mid Grey_Orange/fronts_jump": 2,
  "Diamond/Mid Grey_Orange/full_jump": 2,
  "Diamond/Mid Grey_Peanut Butter/full": 2,
  "Diamond/Mid Grey_Peanut Butter/fronts": 2,
  "Diamond/Mid Grey_Peanut Butter/backs": 2,
  "Diamond/Mid Grey_Peanut Butter/fronts_jump": 2,
  "Diamond/Mid Grey_Peanut Butter/full_jump": 2,
  "Diamond/Mid Grey_Pink/full": 2,
  "Diamond/Mid Grey_Pink/fronts": 2,
  "Diamond/Mid Grey_Pink/backs": 2,
  "Diamond/Mid Grey_Pink/fronts_jump": 2,
  "Diamond/Mid Grey_Pink/full_jump": 2,
  "Diamond/Mid Grey_Red/full": 2,
  "Diamond/Mid Grey_Red/fronts": 2,
  "Diamond/Mid Grey_Red/backs": 2,
  "Diamond/Mid Grey_Red/fronts_jump": 2,
  "Diamond/Mid Grey_Red/full_jump": 2,
  "Diamond/Mid Grey_Royal Blue/full": 2,
  "Diamond/Mid Grey_Royal Blue/fronts": 2,
  "Diamond/Mid Grey_Royal Blue/backs": 2,
  "Diamond/Mid Grey_Royal Blue/fronts_jump": 2,
  "Diamond/Mid Grey_Royal Blue/full_jump": 2,
  "Diamond/Mid Grey_Saddle Brown/full": 2,
  "Diamond/Mid Grey_Saddle Brown/fronts": 2,
  "Diamond/Mid Grey_Saddle Brown/backs": 2,
  "Diamond/Mid Grey_Saddle Brown/fronts_jump": 2,
  "Diamond/Mid Grey_Saddle Brown/full_jump": 2,
  "Diamond/Mid Grey_Sage Grey/full": 2,
  "Diamond/Mid Grey_Sage Grey/fronts": 2,
  "Diamond/Mid Grey_Sage Grey/backs": 2,
  "Diamond/Mid Grey_Sage Grey/fronts_jump": 2,
  "Diamond/Mid Grey_Sage Grey/full_jump": 2,
  "Diamond/Mid Grey_Sand/full": 2,
  "Diamond/Mid Grey_Sand/fronts": 2,
  "Diamond/Mid Grey_Sand/backs": 2,
  "Diamond/Mid Grey_Sand/fronts_jump": 2,
  "Diamond/Mid Grey_Sand/full_jump": 2,
  "Diamond/Mid Grey_Sky Blue/full": 2,
  "Diamond/Mid Grey_Sky Blue/fronts": 2,
  "Diamond/Mid Grey_Sky Blue/backs": 2,
  "Diamond/Mid Grey_Sky Blue/fronts_jump": 2,
  "Diamond/Mid Grey_Sky Blue/full_jump": 2,
  "Diamond/Mid Grey_Slate Blue/full": 2,
  "Diamond/Mid Grey_Slate Blue/fronts": 2,
  "Diamond/Mid Grey_Slate Blue/backs": 2,
  "Diamond/Mid Grey_Slate Blue/fronts_jump": 2,
  "Diamond/Mid Grey_Slate Blue/full_jump": 2,
  "Diamond/Mid Grey_Slate Grey/full": 2,
  "Diamond/Mid Grey_Slate Grey/fronts": 2,
  "Diamond/Mid Grey_Slate Grey/backs": 2,
  "Diamond/Mid Grey_Slate Grey/fronts_jump": 2,
  "Diamond/Mid Grey_Slate Grey/full_jump": 2,
  "Diamond/Mid Grey_Soft Plum/full": 2,
  "Diamond/Mid Grey_Soft Plum/fronts": 2,
  "Diamond/Mid Grey_Soft Plum/backs": 2,
  "Diamond/Mid Grey_Soft Plum/fronts_jump": 2,
  "Diamond/Mid Grey_Soft Plum/full_jump": 2,
  "Diamond/Mid Grey_Steel Blue/full": 2,
  "Diamond/Mid Grey_Steel Blue/fronts": 2,
  "Diamond/Mid Grey_Steel Blue/backs": 2,
  "Diamond/Mid Grey_Steel Blue/fronts_jump": 2,
  "Diamond/Mid Grey_Steel Blue/full_jump": 2,
  "Diamond/Mid Grey_Warm Khaki/full": 2,
  "Diamond/Mid Grey_Warm Khaki/fronts": 2,
  "Diamond/Mid Grey_Warm Khaki/backs": 2,
  "Diamond/Mid Grey_Warm Khaki/fronts_jump": 2,
  "Diamond/Mid Grey_Warm Khaki/full_jump": 2,
  "Diamond/Mid Grey_White/full": 2,
  "Diamond/Mid Grey_White/fronts": 2,
  "Diamond/Mid Grey_White/backs": 2,
  "Diamond/Mid Grey_White/fronts_jump": 2,
  "Diamond/Mid Grey_White/full_jump": 2,
  "Diamond/Mid Grey_Wine Red/full": 2,
  "Diamond/Mid Grey_Wine Red/fronts": 2,
  "Diamond/Mid Grey_Wine Red/backs": 2,
  "Diamond/Mid Grey_Wine Red/fronts_jump": 2,
  "Diamond/Mid Grey_Wine Red/full_jump": 2,
  "Diamond/Midnight Blue_Mid Grey/full": 2,
  "Diamond/Midnight Blue_Mid Grey/fronts": 2,
  "Diamond/Midnight Blue_Mid Grey/backs": 2,
  "Diamond/Midnight Blue_Mid Grey/fronts_jump": 2,
  "Diamond/Midnight Blue_Mid Grey/full_jump": 2,
  "Diamond/Olive Green_Mid Grey/full": 2,
  "Diamond/Olive Green_Mid Grey/fronts": 2,
  "Diamond/Olive Green_Mid Grey/backs": 2,
  "Diamond/Olive Green_Mid Grey/fronts_jump": 2,
  "Diamond/Olive Green_Mid Grey/full_jump": 2,
  "Diamond/Orange_Mid Grey/full": 2,
  "Diamond/Orange_Mid Grey/fronts": 2,
  "Diamond/Orange_Mid Grey/backs": 2,
  "Diamond/Orange_Mid Grey/fronts_jump": 2,
  "Diamond/Orange_Mid Grey/full_jump": 2,
  "Diamond/Peanut Butter_Mid Grey/full": 2,
  "Diamond/Peanut Butter_Mid Grey/fronts": 2,
  "Diamond/Peanut Butter_Mid Grey/backs": 2,
  "Diamond/Peanut Butter_Mid Grey/fronts_jump": 2,
  "Diamond/Peanut Butter_Mid Grey/full_jump": 2,
  "Diamond/Pink_Mid Grey/full": 2,
  "Diamond/Pink_Mid Grey/fronts": 2,
  "Diamond/Pink_Mid Grey/backs": 2,
  "Diamond/Pink_Mid Grey/fronts_jump": 2,
  "Diamond/Pink_Mid Grey/full_jump": 2,
  "Diamond/Red_Mid Grey/full": 2,
  "Diamond/Red_Mid Grey/fronts": 2,
  "Diamond/Red_Mid Grey/backs": 2,
  "Diamond/Red_Mid Grey/fronts_jump": 2,
  "Diamond/Red_Mid Grey/full_jump": 2,
  "Diamond/Royal Blue_Mid Grey/full": 2,
  "Diamond/Royal Blue_Mid Grey/fronts": 2,
  "Diamond/Royal Blue_Mid Grey/backs": 2,
  "Diamond/Royal Blue_Mid Grey/fronts_jump": 2,
  "Diamond/Royal Blue_Mid Grey/full_jump": 2,
  "Diamond/Saddle Brown_Mid Grey/full": 2,
  "Diamond/Saddle Brown_Mid Grey/fronts": 2,
  "Diamond/Saddle Brown_Mid Grey/backs": 2,
  "Diamond/Saddle Brown_Mid Grey/fronts_jump": 2,
  "Diamond/Saddle Brown_Mid Grey/full_jump": 2,
  "Diamond/Sage Grey_Mid Grey/full": 2,
  "Diamond/Sage Grey_Mid Grey/fronts": 2,
  "Diamond/Sage Grey_Mid Grey/backs": 2,
  "Diamond/Sage Grey_Mid Grey/fronts_jump": 2,
  "Diamond/Sage Grey_Mid Grey/full_jump": 2,
  "Diamond/Sand_Mid Grey/full": 2,
  "Diamond/Sand_Mid Grey/fronts": 2,
  "Diamond/Sand_Mid Grey/backs": 2,
  "Diamond/Sand_Mid Grey/fronts_jump": 2,
  "Diamond/Sand_Mid Grey/full_jump": 2,
  "Diamond/Sky Blue_Mid Grey/full": 2,
  "Diamond/Sky Blue_Mid Grey/fronts": 2,
  "Diamond/Sky Blue_Mid Grey/backs": 2,
  "Diamond/Sky Blue_Mid Grey/fronts_jump": 2,
  "Diamond/Sky Blue_Mid Grey/full_jump": 2,
  "Diamond/Slate Blue_Mid Grey/full": 2,
  "Diamond/Slate Blue_Mid Grey/fronts": 2,
  "Diamond/Slate Blue_Mid Grey/backs": 2,
  "Diamond/Slate Blue_Mid Grey/fronts_jump": 2,
  "Diamond/Slate Blue_Mid Grey/full_jump": 2,
  "Diamond/Slate Grey_Mid Grey/full": 2,
  "Diamond/Slate Grey_Mid Grey/fronts": 2,
  "Diamond/Slate Grey_Mid Grey/backs": 2,
  "Diamond/Slate Grey_Mid Grey/fronts_jump": 2,
  "Diamond/Slate Grey_Mid Grey/full_jump": 2,
  "Diamond/Soft Plum_Mid Grey/full": 2,
  "Diamond/Soft Plum_Mid Grey/fronts": 2,
  "Diamond/Soft Plum_Mid Grey/backs": 2,
  "Diamond/Soft Plum_Mid Grey/fronts_jump": 2,
  "Diamond/Soft Plum_Mid Grey/full_jump": 2,
  "Diamond/Steel Blue_Mid Grey/full": 2,
  "Diamond/Steel Blue_Mid Grey/fronts": 2,
  "Diamond/Steel Blue_Mid Grey/backs": 2,
  "Diamond/Steel Blue_Mid Grey/fronts_jump": 2,
  "Diamond/Steel Blue_Mid Grey/full_jump": 2,
  "Diamond/Warm Khaki_Mid Grey/full": 2,
  "Diamond/Warm Khaki_Mid Grey/fronts": 2,
  "Diamond/Warm Khaki_Mid Grey/backs": 2,
  "Diamond/Warm Khaki_Mid Grey/fronts_jump": 2,
  "Diamond/Warm Khaki_Mid Grey/full_jump": 2,
  "Diamond/White_Mid Grey/full": 2,
  "Diamond/White_Mid Grey/fronts": 2,
  "Diamond/White_Mid Grey/backs": 2,
  "Diamond/White_Mid Grey/fronts_jump": 2,
  "Diamond/White_Mid Grey/full_jump": 2,
  "Diamond/Wine Red_Mid Grey/full": 2,
  "Diamond/Wine Red_Mid Grey/fronts": 2,
  "Diamond/Wine Red_Mid Grey/backs": 2,
  "Diamond/Wine Red_Mid Grey/fronts_jump": 2,
  "Diamond/Wine Red_Mid Grey/full_jump": 2,
  "Basic/Aqua Blue_Mid Grey/full": 2,
  "Basic/Aqua Blue_Mid Grey/fronts": 2,
  "Basic/Aqua Blue_Mid Grey/backs": 2,
  "Basic/Aqua Blue_Mid Grey/fronts_jump": 2,
  "Basic/Aqua Blue_Mid Grey/full_jump": 2,
  "Basic/Beige_Mid Grey/full": 2,
  "Basic/Beige_Mid Grey/fronts": 2,
  "Basic/Beige_Mid Grey/backs": 2,
  "Basic/Beige_Mid Grey/fronts_jump": 2,
  "Basic/Beige_Mid Grey/full_jump": 2,
  "Basic/Black_Mid Grey/full": 2,
  "Basic/Black_Mid Grey/fronts": 2,
  "Basic/Black_Mid Grey/backs": 2,
  "Basic/Black_Mid Grey/fronts_jump": 2,
  "Basic/Black_Mid Grey/full_jump": 2,
  "Basic/Charcoal Grey_Mid Grey/full": 2,
  "Basic/Charcoal Grey_Mid Grey/fronts": 2,
  "Basic/Charcoal Grey_Mid Grey/backs": 2,
  "Basic/Charcoal Grey_Mid Grey/fronts_jump": 2,
  "Basic/Charcoal Grey_Mid Grey/full_jump": 2,
  "Basic/Dark Mocha_Mid Grey/full": 2,
  "Basic/Dark Mocha_Mid Grey/fronts": 2,
  "Basic/Dark Mocha_Mid Grey/backs": 2,
  "Basic/Dark Mocha_Mid Grey/fronts_jump": 2,
  "Basic/Dark Mocha_Mid Grey/full_jump": 2,
  "Basic/Dark Orange_Mid Grey/full": 2,
  "Basic/Dark Orange_Mid Grey/fronts": 2,
  "Basic/Dark Orange_Mid Grey/backs": 2,
  "Basic/Dark Orange_Mid Grey/fronts_jump": 2,
  "Basic/Dark Orange_Mid Grey/full_jump": 2,
  "Basic/Dark Purple_Mid Grey/full": 2,
  "Basic/Dark Purple_Mid Grey/fronts": 2,
  "Basic/Dark Purple_Mid Grey/backs": 2,
  "Basic/Dark Purple_Mid Grey/fronts_jump": 2,
  "Basic/Dark Purple_Mid Grey/full_jump": 2,
  "Basic/Dark Saddle Brown_Mid Grey/fronts": 2,
  "Basic/Dark Saddle Brown_Mid Grey/backs": 2,
  "Basic/Deep Teal_Mid Grey/full": 2,
  "Basic/Deep Teal_Mid Grey/fronts": 2,
  "Basic/Deep Teal_Mid Grey/backs": 2,
  "Basic/Deep Teal_Mid Grey/fronts_jump": 2,
  "Basic/Deep Teal_Mid Grey/full_jump": 2,
  "Basic/Espresso Brown_Mid Grey/full": 2,
  "Basic/Espresso Brown_Mid Grey/fronts": 2,
  "Basic/Espresso Brown_Mid Grey/backs": 2,
  "Basic/Espresso Brown_Mid Grey/fronts_jump": 2,
  "Basic/Espresso Brown_Mid Grey/full_jump": 2,
  "Basic/Golden Yellow_Mid Grey/full": 2,
  "Basic/Golden Yellow_Mid Grey/fronts": 2,
  "Basic/Golden Yellow_Mid Grey/backs": 2,
  "Basic/Golden Yellow_Mid Grey/fronts_jump": 2,
  "Basic/Golden Yellow_Mid Grey/full_jump": 2,
  "Basic/Lavender_Mid Grey/full": 2,
  "Basic/Lavender_Mid Grey/fronts": 2,
  "Basic/Lavender_Mid Grey/backs": 2,
  "Basic/Lavender_Mid Grey/fronts_jump": 2,
  "Basic/Lavender_Mid Grey/full_jump": 2,
  "Basic/Light Grey_Mid Grey/full": 2,
  "Basic/Light Grey_Mid Grey/fronts": 2,
  "Basic/Light Grey_Mid Grey/backs": 2,
  "Basic/Light Grey_Mid Grey/fronts_jump": 2,
  "Basic/Light Grey_Mid Grey/full_jump": 2,
  "Basic/Lime Green_Mid Grey/full": 2,
  "Basic/Lime Green_Mid Grey/fronts": 2,
  "Basic/Lime Green_Mid Grey/backs": 2,
  "Basic/Lime Green_Mid Grey/fronts_jump": 2,
  "Basic/Lime Green_Mid Grey/full_jump": 2,
  "Basic/Mid Grey_Aqua Blue/full": 2,
  "Basic/Mid Grey_Aqua Blue/fronts": 2,
  "Basic/Mid Grey_Aqua Blue/backs": 2,
  "Basic/Mid Grey_Aqua Blue/fronts_jump": 2,
  "Basic/Mid Grey_Aqua Blue/full_jump": 2,
  "Basic/Mid Grey_Beige/full": 2,
  "Basic/Mid Grey_Beige/fronts": 2,
  "Basic/Mid Grey_Beige/backs": 2,
  "Basic/Mid Grey_Beige/fronts_jump": 2,
  "Basic/Mid Grey_Beige/full_jump": 2,
  "Basic/Mid Grey_Black/full": 2,
  "Basic/Mid Grey_Black/fronts": 2,
  "Basic/Mid Grey_Black/backs": 2,
  "Basic/Mid Grey_Black/fronts_jump": 2,
  "Basic/Mid Grey_Black/full_jump": 2,
  "Basic/Mid Grey_Charcoal Grey/fronts": 2,
  "Basic/Mid Grey_Charcoal Grey/backs": 2,
  "Basic/Mid Grey_Dark Mocha/fronts": 2,
  "Basic/Mid Grey_Dark Mocha/backs": 2,
  "Basic/Mid Grey_Dark Orange/full": 2,
  "Basic/Mid Grey_Dark Orange/fronts": 2,
  "Basic/Mid Grey_Dark Orange/backs": 2,
  "Basic/Mid Grey_Dark Orange/fronts_jump": 2,
  "Basic/Mid Grey_Dark Orange/full_jump": 2,
  "Basic/Mid Grey_Dark Purple/full": 2,
  "Basic/Mid Grey_Dark Purple/fronts": 2,
  "Basic/Mid Grey_Dark Purple/backs": 2,
  "Basic/Mid Grey_Dark Purple/fronts_jump": 2,
  "Basic/Mid Grey_Dark Purple/full_jump": 2,
  "Basic/Mid Grey_Dark Saddle Brown/full": 2,
  "Basic/Mid Grey_Dark Saddle Brown/fronts": 2,
  "Basic/Mid Grey_Dark Saddle Brown/backs": 2,
  "Basic/Mid Grey_Dark Saddle Brown/fronts_jump": 2,
  "Basic/Mid Grey_Dark Saddle Brown/full_jump": 2,
  "Basic/Mid Grey_Deep Teal/full": 2,
  "Basic/Mid Grey_Deep Teal/fronts": 2,
  "Basic/Mid Grey_Deep Teal/backs": 2,
  "Basic/Mid Grey_Deep Teal/fronts_jump": 2,
  "Basic/Mid Grey_Deep Teal/full_jump": 2,
  "Basic/Mid Grey_Espresso Brown/full": 2,
  "Basic/Mid Grey_Espresso Brown/fronts": 2,
  "Basic/Mid Grey_Espresso Brown/backs": 2,
  "Basic/Mid Grey_Espresso Brown/fronts_jump": 2,
  "Basic/Mid Grey_Espresso Brown/full_jump": 2,
  "Basic/Mid Grey_Golden Yellow/full": 2,
  "Basic/Mid Grey_Golden Yellow/fronts": 2,
  "Basic/Mid Grey_Golden Yellow/backs": 2,
  "Basic/Mid Grey_Golden Yellow/fronts_jump": 2,
  "Basic/Mid Grey_Golden Yellow/full_jump": 2,
  "Basic/Mid Grey_Lavender/full": 2,
  "Basic/Mid Grey_Lavender/fronts": 2,
  "Basic/Mid Grey_Lavender/backs": 2,
  "Basic/Mid Grey_Lavender/fronts_jump": 2,
  "Basic/Mid Grey_Lavender/full_jump": 2,
  "Basic/Mid Grey_Light Grey/full": 2,
  "Basic/Mid Grey_Light Grey/fronts": 2,
  "Basic/Mid Grey_Light Grey/backs": 2,
  "Basic/Mid Grey_Light Grey/fronts_jump": 2,
  "Basic/Mid Grey_Light Grey/full_jump": 2,
  "Basic/Mid Grey_Lime Green/full": 2,
  "Basic/Mid Grey_Lime Green/fronts": 2,
  "Basic/Mid Grey_Lime Green/backs": 2,
  "Basic/Mid Grey_Lime Green/fronts_jump": 2,
  "Basic/Mid Grey_Lime Green/full_jump": 2,
  "Basic/Mid Grey/full": 2,
  "Basic/Mid Grey/fronts": 2,
  "Basic/Mid Grey/backs": 2,
  "Basic/Mid Grey/fronts_jump": 2,
  "Basic/Mid Grey/full_jump": 2,
  "Basic/Mid Grey_Midnight Blue/full": 2,
  "Basic/Mid Grey_Midnight Blue/fronts": 2,
  "Basic/Mid Grey_Midnight Blue/backs": 2,
  "Basic/Mid Grey_Midnight Blue/fronts_jump": 2,
  "Basic/Mid Grey_Midnight Blue/full_jump": 2,
  "Basic/Mid Grey_Olive Green/full": 2,
  "Basic/Mid Grey_Olive Green/fronts": 2,
  "Basic/Mid Grey_Olive Green/backs": 2,
  "Basic/Mid Grey_Olive Green/fronts_jump": 2,
  "Basic/Mid Grey_Olive Green/full_jump": 2,
  "Basic/Mid Grey_Orange/full": 2,
  "Basic/Mid Grey_Orange/fronts": 2,
  "Basic/Mid Grey_Orange/backs": 2,
  "Basic/Mid Grey_Orange/fronts_jump": 2,
  "Basic/Mid Grey_Orange/full_jump": 2,
  "Basic/Mid Grey_Peanut Butter/full": 2,
  "Basic/Mid Grey_Peanut Butter/fronts": 2,
  "Basic/Mid Grey_Peanut Butter/backs": 2,
  "Basic/Mid Grey_Peanut Butter/fronts_jump": 2,
  "Basic/Mid Grey_Peanut Butter/full_jump": 2,
  "Basic/Mid Grey_Pink/full": 2,
  "Basic/Mid Grey_Pink/fronts": 2,
  "Basic/Mid Grey_Pink/backs": 2,
  "Basic/Mid Grey_Pink/fronts_jump": 2,
  "Basic/Mid Grey_Pink/full_jump": 2,
  "Basic/Mid Grey_Red/full": 2,
  "Basic/Mid Grey_Red/fronts": 2,
  "Basic/Mid Grey_Red/backs": 2,
  "Basic/Mid Grey_Red/fronts_jump": 2,
  "Basic/Mid Grey_Red/full_jump": 2,
  "Basic/Mid Grey_Royal Blue/full": 2,
  "Basic/Mid Grey_Royal Blue/fronts": 2,
  "Basic/Mid Grey_Royal Blue/backs": 2,
  "Basic/Mid Grey_Royal Blue/fronts_jump": 2,
  "Basic/Mid Grey_Royal Blue/full_jump": 2,
  "Basic/Mid Grey_Saddle Brown/full": 2,
  "Basic/Mid Grey_Saddle Brown/fronts": 2,
  "Basic/Mid Grey_Saddle Brown/backs": 2,
  "Basic/Mid Grey_Saddle Brown/fronts_jump": 2,
  "Basic/Mid Grey_Saddle Brown/full_jump": 2,
  "Basic/Mid Grey_Sage Grey/full": 2,
  "Basic/Mid Grey_Sage Grey/fronts": 2,
  "Basic/Mid Grey_Sage Grey/backs": 2,
  "Basic/Mid Grey_Sage Grey/fronts_jump": 2,
  "Basic/Mid Grey_Sage Grey/full_jump": 2,
  "Basic/Mid Grey_Sand/full": 2,
  "Basic/Mid Grey_Sand/fronts": 2,
  "Basic/Mid Grey_Sand/backs": 2,
  "Basic/Mid Grey_Sand/fronts_jump": 2,
  "Basic/Mid Grey_Sand/full_jump": 2,
  "Basic/Mid Grey_Sky Blue/full": 2,
  "Basic/Mid Grey_Sky Blue/fronts": 2,
  "Basic/Mid Grey_Sky Blue/backs": 2,
  "Basic/Mid Grey_Sky Blue/fronts_jump": 2,
  "Basic/Mid Grey_Sky Blue/full_jump": 2,
  "Basic/Mid Grey_Slate Blue/full": 2,
  "Basic/Mid Grey_Slate Blue/fronts": 2,
  "Basic/Mid Grey_Slate Blue/backs": 2,
  "Basic/Mid Grey_Slate Blue/fronts_jump": 2,
  "Basic/Mid Grey_Slate Blue/full_jump": 2,
  "Basic/Mid Grey_Slate Grey/full": 2,
  "Basic/Mid Grey_Slate Grey/fronts": 2,
  "Basic/Mid Grey_Slate Grey/backs": 2,
  "Basic/Mid Grey_Slate Grey/fronts_jump": 2,
  "Basic/Mid Grey_Slate Grey/full_jump": 2,
  "Basic/Mid Grey_Soft Plum/full": 2,
  "Basic/Mid Grey_Soft Plum/fronts": 2,
  "Basic/Mid Grey_Soft Plum/backs": 2,
  "Basic/Mid Grey_Soft Plum/fronts_jump": 2,
  "Basic/Mid Grey_Soft Plum/full_jump": 2,
  "Basic/Mid Grey_Steel Blue/full": 2,
  "Basic/Mid Grey_Steel Blue/fronts": 2,
  "Basic/Mid Grey_Steel Blue/backs": 2,
  "Basic/Mid Grey_Steel Blue/fronts_jump": 2,
  "Basic/Mid Grey_Steel Blue/full_jump": 2,
  "Basic/Mid Grey_Warm Khaki/full": 2,
  "Basic/Mid Grey_Warm Khaki/fronts": 2,
  "Basic/Mid Grey_Warm Khaki/backs": 2,
  "Basic/Mid Grey_Warm Khaki/fronts_jump": 2,
  "Basic/Mid Grey_Warm Khaki/full_jump": 2,
  "Basic/Mid Grey_White/full": 2,
  "Basic/Mid Grey_White/fronts": 2,
  "Basic/Mid Grey_White/backs": 2,
  "Basic/Mid Grey_White/fronts_jump": 2,
  "Basic/Mid Grey_White/full_jump": 2,
  "Basic/Mid Grey_Wine Red/full": 2,
  "Basic/Mid Grey_Wine Red/fronts": 2,
  "Basic/Mid Grey_Wine Red/backs": 2,
  "Basic/Mid Grey_Wine Red/fronts_jump": 2,
  "Basic/Mid Grey_Wine Red/full_jump": 2,
  "Basic/Midnight Blue_Mid Grey/full": 2,
  "Basic/Midnight Blue_Mid Grey/fronts": 2,
  "Basic/Midnight Blue_Mid Grey/backs": 2,
  "Basic/Midnight Blue_Mid Grey/fronts_jump": 2,
  "Basic/Midnight Blue_Mid Grey/full_jump": 2,
  "Basic/Olive Green_Mid Grey/full": 2,
  "Basic/Olive Green_Mid Grey/fronts": 2,
  "Basic/Olive Green_Mid Grey/backs": 2,
  "Basic/Olive Green_Mid Grey/fronts_jump": 2,
  "Basic/Olive Green_Mid Grey/full_jump": 2,
  "Basic/Orange_Mid Grey/full": 2,
  "Basic/Orange_Mid Grey/fronts": 2,
  "Basic/Orange_Mid Grey/backs": 2,
  "Basic/Orange_Mid Grey/fronts_jump": 2,
  "Basic/Orange_Mid Grey/full_jump": 2,
  "Basic/Peanut Butter_Mid Grey/full": 2,
  "Basic/Peanut Butter_Mid Grey/fronts": 2,
  "Basic/Peanut Butter_Mid Grey/backs": 2,
  "Basic/Peanut Butter_Mid Grey/fronts_jump": 2,
  "Basic/Peanut Butter_Mid Grey/full_jump": 2,
  "Basic/Pink_Mid Grey/full": 2,
  "Basic/Pink_Mid Grey/fronts": 2,
  "Basic/Pink_Mid Grey/backs": 2,
  "Basic/Pink_Mid Grey/fronts_jump": 2,
  "Basic/Pink_Mid Grey/full_jump": 2,
  "Basic/Red_Mid Grey/full": 2,
  "Basic/Red_Mid Grey/fronts": 2,
  "Basic/Red_Mid Grey/backs": 2,
  "Basic/Red_Mid Grey/fronts_jump": 2,
  "Basic/Red_Mid Grey/full_jump": 2,
  "Basic/Royal Blue_Mid Grey/full": 2,
  "Basic/Royal Blue_Mid Grey/fronts": 2,
  "Basic/Royal Blue_Mid Grey/backs": 2,
  "Basic/Royal Blue_Mid Grey/fronts_jump": 2,
  "Basic/Royal Blue_Mid Grey/full_jump": 2,
  "Basic/Saddle Brown_Mid Grey/full": 2,
  "Basic/Saddle Brown_Mid Grey/fronts": 2,
  "Basic/Saddle Brown_Mid Grey/backs": 2,
  "Basic/Saddle Brown_Mid Grey/fronts_jump": 2,
  "Basic/Saddle Brown_Mid Grey/full_jump": 2,
  "Basic/Sage Grey_Mid Grey/full": 2,
  "Basic/Sage Grey_Mid Grey/fronts": 2,
  "Basic/Sage Grey_Mid Grey/backs": 2,
  "Basic/Sage Grey_Mid Grey/fronts_jump": 2,
  "Basic/Sage Grey_Mid Grey/full_jump": 2,
  "Basic/Sand_Mid Grey/full": 2,
  "Basic/Sand_Mid Grey/fronts": 2,
  "Basic/Sand_Mid Grey/backs": 2,
  "Basic/Sand_Mid Grey/fronts_jump": 2,
  "Basic/Sand_Mid Grey/full_jump": 2,
  "Basic/Sky Blue_Mid Grey/full": 2,
  "Basic/Sky Blue_Mid Grey/fronts": 2,
  "Basic/Sky Blue_Mid Grey/backs": 2,
  "Basic/Sky Blue_Mid Grey/fronts_jump": 2,
  "Basic/Sky Blue_Mid Grey/full_jump": 2,
  "Basic/Slate Blue_Mid Grey/full": 2,
  "Basic/Slate Blue_Mid Grey/fronts": 2,
  "Basic/Slate Blue_Mid Grey/backs": 2,
  "Basic/Slate Blue_Mid Grey/fronts_jump": 2,
  "Basic/Slate Blue_Mid Grey/full_jump": 2,
  "Basic/Slate Grey_Mid Grey/fronts": 2,
  "Basic/Slate Grey_Mid Grey/backs": 2,
  "Basic/Soft Plum_Mid Grey/full": 2,
  "Basic/Soft Plum_Mid Grey/fronts": 2,
  "Basic/Soft Plum_Mid Grey/backs": 2,
  "Basic/Soft Plum_Mid Grey/fronts_jump": 2,
  "Basic/Soft Plum_Mid Grey/full_jump": 2,
  "Basic/Steel Blue_Mid Grey/full": 2,
  "Basic/Steel Blue_Mid Grey/fronts": 2,
  "Basic/Steel Blue_Mid Grey/backs": 2,
  "Basic/Steel Blue_Mid Grey/fronts_jump": 2,
  "Basic/Steel Blue_Mid Grey/full_jump": 2,
  "Basic/Warm Khaki_Mid Grey/full": 2,
  "Basic/Warm Khaki_Mid Grey/fronts": 2,
  "Basic/Warm Khaki_Mid Grey/backs": 2,
  "Basic/Warm Khaki_Mid Grey/fronts_jump": 2,
  "Basic/Warm Khaki_Mid Grey/full_jump": 2,
  "Basic/White_Mid Grey/full": 2,
  "Basic/White_Mid Grey/fronts": 2,
  "Basic/White_Mid Grey/backs": 2,
  "Basic/White_Mid Grey/fronts_jump": 2,
  "Basic/White_Mid Grey/full_jump": 2,
  "Basic/Wine Red_Mid Grey/full": 2,
  "Basic/Wine Red_Mid Grey/fronts": 2,
  "Basic/Wine Red_Mid Grey/backs": 2,
  "Basic/Wine Red_Mid Grey/fronts_jump": 2,
  "Basic/Wine Red_Mid Grey/full_jump": 2
 }
};
